
/**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that "directory" and not name of the baseName's
                //module. For instance, baseName of "one/two/three", maps to
                //"one/two/three.js", but we want the directory, "one/two" for
                //this normalization.
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                name = baseParts.concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());
define("libs/almond.js", function(){});

/*!
 * routie - a tiny hash router
 * v0.3.2
 * http://projects.jga.me/routie
 * copyright Greg Allen 2013
 * MIT License
*/
(function(n){var e=[],t={},r="routie",o=n[r],i=function(n,e){this.name=e,this.path=n,this.keys=[],this.fns=[],this.params={},this.regex=a(this.path,this.keys,!1,!1)};i.prototype.addHandler=function(n){this.fns.push(n)},i.prototype.removeHandler=function(n){for(var e=0,t=this.fns.length;t>e;e++){var r=this.fns[e];if(n==r)return this.fns.splice(e,1),void 0}},i.prototype.run=function(n){for(var e=0,t=this.fns.length;t>e;e++)this.fns[e].apply(this,n)},i.prototype.match=function(n,e){var t=this.regex.exec(n);if(!t)return!1;for(var r=1,o=t.length;o>r;++r){var i=this.keys[r-1],a="string"==typeof t[r]?decodeURIComponent(t[r]):t[r];i&&(this.params[i.name]=a),e.push(a)}return!0},i.prototype.toURL=function(n){var e=this.path;for(var t in n)e=e.replace("/:"+t,"/"+n[t]);if(e=e.replace(/\/:.*\?/g,"/").replace(/\?/g,""),-1!=e.indexOf(":"))throw Error("missing parameters for url: "+e);return e};var a=function(n,e,t,r){return n instanceof RegExp?n:(n instanceof Array&&(n="("+n.join("|")+")"),n=n.concat(r?"":"/?").replace(/\/\(/g,"(?:/").replace(/\+/g,"__plus__").replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?/g,function(n,t,r,o,i,a){return e.push({name:o,optional:!!a}),t=t||"",""+(a?"":t)+"(?:"+(a?t:"")+(r||"")+(i||r&&"([^/.]+?)"||"([^/]+?)")+")"+(a||"")}).replace(/([\/.])/g,"\\$1").replace(/__plus__/g,"(.+)").replace(/\*/g,"(.*)"),RegExp("^"+n+"$",t?"":"i"))},s=function(n,r){var o=n.split(" "),a=2==o.length?o[0]:null;n=2==o.length?o[1]:o[0],t[n]||(t[n]=new i(n,a),e.push(t[n])),t[n].addHandler(r)},h=function(n,e){if("function"==typeof e)s(n,e),h.reload();else if("object"==typeof n){for(var t in n)s(t,n[t]);h.reload()}else e===void 0&&h.navigate(n)};h.lookup=function(n,t){for(var r=0,o=e.length;o>r;r++){var i=e[r];if(i.name==n)return i.toURL(t)}},h.remove=function(n,e){var r=t[n];r&&r.removeHandler(e)},h.removeAll=function(){t={},e=[]},h.navigate=function(n,e){e=e||{};var t=e.silent||!1;t&&l(),setTimeout(function(){window.location.hash=n,t&&setTimeout(function(){p()},1)},1)},h.noConflict=function(){return n[r]=o,h};var f=function(){return window.location.hash.substring(1)},c=function(n,e){var t=[];return e.match(n,t)?(e.run(t),!0):!1},u=h.reload=function(){for(var n=f(),t=0,r=e.length;r>t;t++){var o=e[t];if(c(n,o))return}},p=function(){n.addEventListener?n.addEventListener("hashchange",u,!1):n.attachEvent("onhashchange",u)},l=function(){n.removeEventListener?n.removeEventListener("hashchange",u):n.detachEvent("onhashchange",u)};p(),n[r]=h})(window);
define("libs/routie", function(){});

define('libs/core',[
	"libs/routie"
],function(){

	function show(path, config){
		if (config == -1)
			return render_sub_stack(this, path);
		if (this._subs[path])
			return render_sub_stack(this._subs[path], config);
		

		var scope = get_app_scope(this);
		var index = this.index;

		if (typeof path == "string"){
			var index = index;

			//child page
			if (path.indexOf("./") === 0){
				index++;
				path = path.substr(2);
			}

			//route to page
			var parsed = parse_parts(path);
			scope.path = scope.path.slice(0, index).concat(parsed);
		} else {
			//set parameters
			webix.extend(scope.path[index].params, path, true);
		}

		scope.show(url_string(scope.path), -1);
	}

	function get_app_scope(scope){
		while(scope){
			if (scope.app)
				return scope;
			scope = scope.parent;
		}
		return app;
	}

	function url_string(stack){
		var url = [];
		var start = app.config.layout ? 1 : 0;

		for (; start<stack.length; start++){
			url.push("/"+stack[start].page);
			var params = params_string(stack[start].params);
			if (params)
				url.push(":"+params);
		}

		return url.join("");
	}
	function params_string(obj){
		var str = [];
		for (var key in obj){
			if (str.length)
				str.push(":");
			str.push(key+"="+obj[key]);
		}
		
		return str.join("");
	}


	function subui(ui, name, stack){
		if (run_plugins(url_plugins, ui, name, stack, this) === false) return;

		if (name.page != this.name){
			this.name = name.page;
			this.ui = create_temp_ui;
			this.on = create_temp_event;
			this.show = show;
			this.module = ui;
			
			destroy.call(this);

			//collect init and destory handlers
			//set subview container
			this._init = [];
			this._destroy = [];
			this._subs = {};
			this.$layout = false;

			var subview = copy(ui, null, this);
				subview.$scope = this;

			create.call(this, subview);
		
			//prepare layout for view loading
			if (this.$layout){
				this.$layout = {
					root : (this._ui.$$ || webix.$$)(this.name+":subview"),
					sub: 		subui,
					parent: 	this,
					index: 		this.index + 1
				};
			}
		}

		run_plugins(ui_plugins, ui, name, stack, this);

		if (!ui.$onurlchange || ui.$onurlchange.call(ui, name.params, stack, this) !== false)
			return this.$layout;
	}

	function parse_parts(url){
		//split url by "/"
		var chunks = url.split("/");
		
		//use optional default layout page
		if (!chunks[0]){
			if (app.config.layout)
			 	chunks[0] = app.config.layout;
			else
				chunks.shift();
		}

		//for each page in url
		for (var i = 0; i < chunks.length; i++){
			var test = chunks[i];
			var result = [];

			//detect params
			var pos = test.indexOf(":");
			if (pos !== -1){
				var params = test.substr(pos+1).split(":");
				//detect named params
				var objmode = params[0].indexOf("=") !== -1;

				//create hash of named params
				if (objmode){
					result = {};
					for (var j = 0; j < params.length; j++) {
						var dchunk = params[j].split("=");
						result[dchunk[0]] = dchunk[1];
					}
				} else {
					result = params;
				}
			}
			
			//store parsed values
			chunks[i] = { page: (pos > -1 ? test.substr(0, pos) : test), params:result };
		}

		//return array of page objects
		return chunks;
	}

	function copy(obj, target, config){
		if (obj.$oninit)
			config._init.push(obj.$oninit);
		if (obj.$ondestroy)
			config._destroy.push(obj.$ondestroy);
		if (obj.$subview){
			if (typeof obj.$subview == "string"){
				var tname = (config.name + ":subview:"+obj.$subview);
				var tobj = config._subs[obj.$subview] = { 
					parent:this,
					root: tname,
					sub:subui,
					index:0,
					app:true
				};

				obj.id   = tname;
			} else {
				obj = { id: (config.name + ":subview") };
				config.$layout = true;
			}
		}
		if (obj.$ui)
			obj = obj.$ui;
		if (obj.$init){
			return obj;
		}
	
		target = target || (webix.isArray(obj)?[]:{});
		for (var method in obj){
			if(obj[method] && typeof obj[method] == "object" && !webix.isDate(obj[method])){
				target[method] = copy(obj[method], (webix.isArray(obj[method])?[]:{}), config);
			} else {
				target[method] = obj[method];
			}
		}

		return target;
	}

	function render_sub_stack(scope, path){
		if (scope.root)
			scope.root = webix.$$(scope.root);

		var parts = parse_parts(path);
		scope.path = [].concat(parts);
		render_stack(scope, parts);
	}

	function render_stack(layout, stack){
		var line = stack[0];
		if (line){
			var url = line.page;
			var issubpage = url.indexOf(".") === 0;

			if (issubpage)
				url = (layout.fullname||"")+url;
			url = url.replace(/\./g,"/");

			if (run_plugins(require_plugins, url, line, stack, layout) === false) return;

			require(["views/" + url], function(ui){
				stack.shift();

				var next = layout.sub(ui, line, stack);
				if (next){
					next.fullname = (issubpage ? (layout.fullname || "") : "") + line.page;
					render_stack(next, stack);
				} else {
					webix.ui.$freeze = false;
					webix.ui.resize();
				}
			});
		} else {
			webix.ui.$freeze = false;
			webix.ui.resize();
		}
	}

	var ui_plugins = [];
	var url_plugins = [];
	var require_plugins = [];
	function run_plugins(plugins, ui, name, stack, scope){
		for (var i = 0; i < plugins.length; i++)
			if (plugins[i](ui, name, stack, scope) === false) return false;
		return true;
	}

	var app = {
		create:function(config){
			//init config
			app.config = webix.extend({
				name:"App",
				version:"1.0",
				container: document.body,
				start:"/home"
			}, config, true);

			//init self
			app.debug = config.debug;
			app.$layout = {
				sub:subui,
				root: app.config.container,
				index:0,
				add:true
			};
			webix.extend(app, webix.EventSystem);

			//show start page
			setTimeout(function(){
				webix.ready(function(){
					app.start();
				});
			},1);

			
			
			var node = app.config.container;
			webix.html.addCss(node, "webixappstart");
			setTimeout(function(){
				webix.html.removeCss(node, "webixappstart");
				webix.html.addCss(node, "webixapp");
			}, 10);

			return app;
		},

		ui:create_temp_ui,


		//navigation
		router:function(name){
			var parts = parse_parts(name);
			app.path = [].concat(parts);

			//webix.ui.$freeze = true;
			render_stack(app.$layout, parts);
		},
		show:function(name, options){
			routie.navigate("!"+name, options);
		},
		start:function(name){
			//init routing
			routie("!*",		app.router);

			if (!window.location.hash)
				app.show(app.config.start);
			 else {
				webix.ui.$freeze = false;
				webix.ui.resize();
 			}
 		},


		//plugins
		use:function(handler, config){
			if (handler.$oninit)
				handler.$oninit(this, (config || {}) );

			if (handler.$onurlchange)
				url_plugins.push(handler.$onurlchange);
			if (handler.$onurl)
				require_plugins.push(handler.$onurl);
			if (handler.$onui)
				ui_plugins.push(handler.$onui);
		},


		//event helpers
		trigger:function(name){
			app.apply(name, [].splice.call(arguments, 1));
		},
		apply:function(name, data){
			app.callEvent(name, data);
		},
		action:function(name){
			return function(){
				app.apply(name, arguments);
			};
		},
		on:function(name, handler){
			this.attachEvent(name, handler);
		},

		_uis:[],
		_handlers:[]
	};

	function create_temp_event(obj, name, code){
		var id = obj.attachEvent(name, code);
		this._handlers.push({ obj:obj, id:id });
		return id;
	}

	function create_temp_ui(module, container){
		var view;
		var temp = { _init:[], _destroy:[] };
		var ui = copy(module, null, temp);
			ui.$scope = this;

		if (ui.id)
			view = $$(ui.id);
			
		if (!view){
			view = webix.ui(ui, container);
			this._uis.push(view);
			run_handlers(temp._init, view, this);
		}

		return view;
	}

	function run_handlers(arr, view, scope){
		if (arr)
			for (var i = 0; i < arr.length; i++)
				arr[i](view, scope);
	}

	function destroy(){
		if (!this._ui) return;

		if (this.$layout)
			destroy.call(this.$layout);

		var handlers = this._handlers;
		for (var i = handlers.length - 1; i >= 0; i--)
			handlers[i].obj.detachEvent( handlers[i].id );
		this._handlers = [];

		var uis = this._uis;
		for (var i = uis.length - 1; i >= 0; i--)
			if (uis[i] && uis[i].destructor) uis[i].destructor();
		this._uis = [];

		run_handlers(this._destroy, this._ui, this);

		if (!this.parent && this._ui)
			this._ui.destructor();
	}


	function delete_ids(view){
		delete webix.ui.views[view.config.id];
		view.config.id = "";
		var childs = view.getChildViews();
		for (var i = childs.length - 1; i >= 0; i--)
			delete_ids(childs[i]);
	}
	function create(subview){
		this._uis=[];
		this._handlers=[];

		//naive solution for id dupplication
		if (this.root && this.root.config)
			delete_ids(this.root);

		this._ui = webix.ui(subview, this.root);
		if (this.parent)
			this.root = this._ui;

		run_handlers(this._init, this._ui, this);
	}

	function invalid_url(err){
		if (app.debug)
			console.log(err.stack);

		if (!err.requireModules) throw(err);
		if (app.debug)
			webix.message({ type:"error", expire:5000, text:"Can't load "+err.requireModules.join(", ") });

		app.show(app.config.start);
	}

	requirejs.onError = invalid_url;
	return app;
});
define('helpers/menu',[], function(){

	function select_menu(menu_id, id){
		var menu = $$(menu_id);
		if (menu.setValue)
			menu.setValue(id);
		else if (menu.select && menu.exists(id))
			menu.select(id);
	}

	function get_menu(scope){
		if (scope.parent)
			return scope.parent.module.$menu || get_menu(scope.parent);
	}

	return {
		$onurlchange:function(ui, name, url, scope){
			//menu handling
			if (ui.$menuid){
				var id = ui.$menuid.call ? ui.$menuid.call(ui, ui, name, url) : ui.$menuid;
				var menu = get_menu(scope);
				if (menu && id)
					select_menu(menu, id);
			}
		},

		$onui:function(ui, name, url, scope){
			//menu handling
			if (ui.$menu && url.length)
				select_menu(ui.$menu, url[0].page)
		}
	}
});
//     (c) 2012 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//

!function(root) {
  

  // ### Polyglot class constructor
  function Polyglot(options) {
    options = options || {};
    this.phrases = {};
    this.extend(options.phrases || {});
    this.currentLocale = options.locale || 'en';
    this.allowMissing = !!options.allowMissing;
    this.warn = options.warn || warn;
  }

  // ### Version
  Polyglot.VERSION = '0.4.1';

  // ### polyglot.locale([locale])
  //
  // Get or set locale. Internally, Polyglot only uses locale for pluralization.
  Polyglot.prototype.locale = function(newLocale) {
    if (newLocale) this.currentLocale = newLocale;
    return this.currentLocale;
  };

  // ### polyglot.extend(phrases)
  //
  // Use `extend` to tell Polyglot how to translate a given key.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     });
  //
  // The key can be any string.  Feel free to call `extend` multiple times;
  // it will override any phrases with the same key, but leave existing phrases
  // untouched.
  //
  // It is also possible to pass nested phrase objects, which get flattened
  // into an object with the nested keys concatenated using dot notation.
  //
  //     polyglot.extend({
  //       "nav": {
  //         "hello": "Hello",
  //         "hello_name": "Hello, %{name}",
  //         "sidebar": {
  //           "welcome": "Welcome"
  //         }
  //       }
  //     });
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}',
  //     //   'nav.sidebar.welcome': 'Welcome'
  //     // }
  //
  // `extend` accepts an optional second argument, `prefix`, which can be used
  // to prefix every key in the phrases object with some string, using dot
  // notation.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     }, "nav");
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}'
  //     // }
  //
  // This feature is used internally to support nested phrase objects.
  Polyglot.prototype.extend = function(morePhrases, prefix) {
    var phrase;

    for (var key in morePhrases) {
      if (morePhrases.hasOwnProperty(key)) {
        phrase = morePhrases[key];
        if (prefix) key = prefix + '.' + key;
        if (typeof phrase === 'object') {
          this.extend(phrase, key);
        } else {
          this.phrases[key] = phrase;
        }
      }
    }
  };

  // ### polyglot.clear()
  //
  // Clears all phrases. Useful for special cases, such as freeing
  // up memory if you have lots of phrases but no longer need to
  // perform any translation. Also used internally by `replace`.
  Polyglot.prototype.clear = function() {
    this.phrases = {};
  };

  // ### polyglot.replace(phrases)
  //
  // Completely replace the existing phrases with a new set of phrases.
  // Normally, just use `extend` to add more phrases, but under certain
  // circumstances, you may want to make sure no old phrases are lying around.
  Polyglot.prototype.replace = function(newPhrases) {
    this.clear();
    this.extend(newPhrases);
  };


  // ### polyglot.t(key, options)
  //
  // The most-used method. Provide a key, and `t` will return the
  // phrase.
  //
  //     polyglot.t("hello");
  //     => "Hello"
  //
  // The phrase value is provided first by a call to `polyglot.extend()` or
  // `polyglot.replace()`.
  //
  // Pass in an object as the second argument to perform interpolation.
  //
  //     polyglot.t("hello_name", {name: "Spike"});
  //     => "Hello, Spike"
  //
  // If you like, you can provide a default value in case the phrase is missing.
  // Use the special option key "_" to specify a default.
  //
  //     polyglot.t("i_like_to_write_in_language", {
  //       _: "I like to write in %{language}.",
  //       language: "JavaScript"
  //     });
  //     => "I like to write in JavaScript."
  //
  Polyglot.prototype.t = function(key, options) {
    var result;
    options = options == null ? {} : options;
    // allow number as a pluralization shortcut
    if (typeof options === 'number') {
      options = {smart_count: options};
    }
    var phrase = this.phrases[key] || options._ || (this.allowMissing ? key : '');
    if (phrase === '') {
      this.warn('Missing translation for key: "'+key+'"');
      result = key;
    } else {
      options = clone(options);
      result = choosePluralForm(phrase, this.currentLocale, options.smart_count);
      result = interpolate(result, options);
    }
    return result;
  };


  // #### Pluralization methods
  // The string that separates the different phrase possibilities.
  var delimeter = '||||';

  // Mapping from pluralization group plural logic.
  var pluralTypes = {
    chinese:   function(n) { return 0; },
    german:    function(n) { return n !== 1 ? 1 : 0; },
    french:    function(n) { return n > 1 ? 1 : 0; },
    russian:   function(n) { return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2; },
    czech:     function(n) { return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2; },
    polish:    function(n) { return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2); },
    icelandic: function(n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
  };

  // Mapping from pluralization group to individual locales.
  var pluralTypeToLanguages = {
    chinese:   ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
    german:    ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
    french:    ['fr', 'tl', 'pt-br'],
    russian:   ['hr', 'ru', 'be'],
    czech:     ['cs'],
    polish:    ['pl'],
    icelandic: ['is']
  };

  function langToTypeMap(mapping) {
    var type, langs, l, ret = {};
    for (type in mapping) {
      if (mapping.hasOwnProperty(type)) {
        langs = mapping[type];
        for (l in langs) {
          ret[langs[l]] = type;
        }
      }
    }
    return ret;
  }

  // Trim a string.
  function trim(str){
    var trimRe = /^\s+|\s+$/g;
    return str.replace(trimRe, '');
  }

  // Based on a phrase text that contains `n` plural forms separated
  // by `delimeter`, a `locale`, and a `count`, choose the correct
  // plural form, or none if `count` is `null`.
  function choosePluralForm(text, locale, count){
    var ret, texts, chosenText;
    if (count != null && text) {
      texts = text.split(delimeter);
      chosenText = texts[pluralTypeIndex(locale, count)] || texts[0];
      ret = trim(chosenText);
    } else {
      ret = text;
    }
    return ret;
  }

  function pluralTypeName(locale) {
    var langToPluralType = langToTypeMap(pluralTypeToLanguages);
    return langToPluralType[locale] || langToPluralType.en;
  }

  function pluralTypeIndex(locale, count) {
    return pluralTypes[pluralTypeName(locale)](count);
  }

  // ### interpolate
  //
  // Does the dirty work. Creates a `RegExp` object for each
  // interpolation placeholder.
  function interpolate(phrase, options) {
    for (var arg in options) {
      if (arg !== '_' && options.hasOwnProperty(arg)) {
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        phrase = phrase.replace(new RegExp('%\\{'+arg+'\\}', 'g'), options[arg]);
      }
    }
    return phrase;
  }

  // ### warn
  //
  // Provides a warning in the console if a phrase key is missing.
  function warn(message) {
    root.console && root.console.warn && root.console.warn('WARNING: ' + message);
  }

  // ### clone
  //
  // Clone an object.
  function clone(source) {
    var ret = {};
    for (var prop in source) {
      ret[prop] = source[prop];
    }
    return ret;
  }


  // Export for Node, attach to `window` for browser.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Polyglot;
  } else {
    root.Polyglot = Polyglot;
  }

}(this);

define("libs/polyglot", function(){});

define('models/user',[

],function(){

	// if you need not custom methods, just use
	// return webix.remote.users;

	//hardcode user
	webix.remote.$user = { id:1 };

	var current_user = webix.remote.$user || null;
	if (current_user)
		setCurrentUser(current_user);

	function setCurrentUser(value, afterlogin){
		//we need to reload document after login out
		if (!value){
			session.logout().then(function(){
				current_user = null;
				document.location.reload();	
			});
			return;
		}
		//we need to reload document when changing active user
		if (current_user && current_user != value){
			document.location.reload();
			return;
		}

		current_user = value;

		var isvalid = (current_user.settings && typeof current_user.settings == "string");
		current_user.settings = isvalid ? JSON.parse(current_user.settings) : {};

		webix.extend(current_user.settings,{
			language:"en",
			theme:"siberia:webix",
			notifications:0
		});

		require(["helpers/locale", "helpers/theme"], function(locale, theme){
			//if user has different theme after login - we need to reload page
			if (afterlogin){
				if (!locale.isNow(current_user.settings.language) ||
				    !theme.isNow(current_user.settings.theme))
				    	document.location.reload();
			}

			//call save to store values in the local store			
			locale.setLang(current_user.settings.language, afterlogin);
			theme.setTheme(current_user.settings.theme, afterlogin);
		});
	}

	function getCurrentUser(){
		return current_user;
	}

	function saveSetting(key, value, reload){
		if(current_user){
			var id = current_user.id,
				settings = current_user.settings;

			if(!settings[key] || value != settings[key]){
				if (reload)
					document.location.reload();
			}
		}
	}


	return {
		saveSetting:saveSetting,
		getCurrentUser:getCurrentUser,
		setCurrentUser:setCurrentUser,
	};

});
define('helpers/locale',[
	"libs/polyglot",
	"models/user"
], function(polyglot, users){

	var defaultlang = "en";
	var key = "--:app:lang";
	var current_lang = "";

	function _get_lang(){
		if(users.getCurrentUser())
			return users.getCurrentUser().settings.language;

		return webix.storage.local.get(key) || defaultlang;
	}
	function _set_lang(lang, init){
		webix.storage.local.put(key, lang);
		if (users.getCurrentUser())
			users.saveSetting("language", lang, lang != current_lang);
		else
			document.location.reload();
	}

	function create_locale(lang){
		current_lang = lang;
		define("locale", [
			"locales/"+lang
		], function(data){
			var poly = new Polyglot({ phrases:data });
				poly.locale(lang);

			var t = webix.bind(poly.t, poly);
			t.template = function(a){
				return a.replace(/%([a-zA-Z0-9.]+)%/g, function(_, match){
					return poly.t(match);
				});
			};
			return t;
		});
	}

	return {
		$oninit:function(app, config){
			key = (app.config.id || "")+key;

			var lang = _get_lang();
			create_locale(lang);
		},
		setLang: _set_lang,
		getLang: _get_lang,
		isNow:function(val){ return val == current_lang; }
	};
});
define('helpers/theme',[
	"models/user"
], function(users){

	var key = "--:app:theme";
	var current_theme = webix.storage.local.get(key) || "siberia:webix";

	function _get_theme(){
		if(users.getCurrentUser())
			return users.getCurrentUser().settings.theme;

		return current_theme;
	}

	function _set_theme(theme){
		webix.storage.local.put(key, theme);
		if(users.getCurrentUser())
			users.saveSetting("theme", theme, theme != current_theme);
		else
			document.location.reload();

		current_theme = theme;
	}

	return {
		setTheme: _set_theme,
		getTheme: _get_theme,
		isNow:function(val){ return val == current_theme; }
	};
});
define('libs/rollbar',['require','exports','module'],function(require,exports,module){function _isUndefined(a){return"undefined"==typeof a}function computeStackTraceWrapper(a){function b(a){if(!t)return"";try{var b=function(){try{return new window.XMLHttpRequest}catch(a){return new window.ActiveXObject("Microsoft.XMLHTTP")}},c=b();return c.open("GET",a,!1),c.send(""),c.responseText}catch(d){return""}}function c(a){if(!s.hasOwnProperty(a)){var c="";-1!==a.indexOf(document.domain)&&(c=b(a)),s[a]=c?c.split("\n"):[]}return s[a]}function d(a,b){var d,e=/function ([^(]*)\(([^)]*)\)/,f=/['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,g="",h=10,i=c(a);if(!i.length)return UNKNOWN_FUNCTION;for(var j=0;h>j;++j)if(g=i[b-j]+g,!_isUndefined(g)){if(d=f.exec(g))return d[1];if(d=e.exec(g))return d[1]}return UNKNOWN_FUNCTION}function e(a,b){var d=c(a);if(!d.length)return null;var e=[],f=Math.floor(u/2),g=f+u%2,h=Math.max(0,b-f-1),i=Math.min(d.length,b+g-1);b-=1;for(var j=h;i>j;++j)_isUndefined(d[j])||e.push(d[j]);return e.length>0?e:null}function f(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g,"\\$&")}function g(a){return f(a).replace("<","(?:<|&lt;)").replace(">","(?:>|&gt;)").replace("&","(?:&|&amp;)").replace('"','(?:"|&quot;)').replace(/\s+/g,"\\s+")}function h(a,b){for(var d,e,f=0,g=b.length;g>f;++f)if((d=c(b[f])).length&&(d=d.join("\n"),e=a.exec(d)))return{url:b[f],line:d.substring(0,e.index).split("\n").length,column:e.index-d.lastIndexOf("\n",e.index)-1};return null}function i(a,b,d){var e,g=c(b),h=new RegExp("\\b"+f(a)+"\\b");return d-=1,g&&g.length>d&&(e=h.exec(g[d]))?e.index:null}function j(a){for(var b,c,d,e,i=[window.location.href],j=document.getElementsByTagName("script"),k=""+a,l=/^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,m=/^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,n=0;n<j.length;++n){var o=j[n];o.src&&i.push(o.src)}if(d=l.exec(k)){var p=d[1]?"\\s+"+d[1]:"",q=d[2].split(",").join("\\s*,\\s*");b=f(d[3]).replace(/;$/,";?"),c=new RegExp("function"+p+"\\s*\\(\\s*"+q+"\\s*\\)\\s*{\\s*"+b+"\\s*}")}else c=new RegExp(f(k).replace(/\s+/g,"\\s+"));if(e=h(c,i))return e;if(d=m.exec(k)){var r=d[1];if(b=g(d[2]),c=new RegExp("on"+r+"=[\\'\"]\\s*"+b+"\\s*[\\'\"]","i"),e=h(c,i[0]))return e;if(c=new RegExp(b),e=h(c,i))return e}return null}function k(a){if(!a.stack)return null;for(var b,c,f=/^\s*at (?:((?:\[object object\])?\S+(?: \[as \S+\])?) )?\(?((?:file|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,g=/^\s*(\S*)(?:\((.*?)\))?@((?:file|http|https).*?):(\d+)(?::(\d+))?\s*$/i,h=a.stack.split("\n"),j=[],k=/^(.*) is undefined$/.exec(a.message),l=0,m=h.length;m>l;++l){if(b=g.exec(h[l]))c={url:b[3],func:b[1]||UNKNOWN_FUNCTION,args:b[2]?b[2].split(","):"",line:+b[4],column:b[5]?+b[5]:null};else{if(!(b=f.exec(h[l])))continue;c={url:b[2],func:b[1]||UNKNOWN_FUNCTION,line:+b[3],column:b[4]?+b[4]:null}}!c.func&&c.line&&(c.func=d(c.url,c.line)),c.line&&(c.context=e(c.url,c.line)),j.push(c)}return j[0]&&j[0].line&&!j[0].column&&k&&(j[0].column=i(k[1],j[0].url,j[0].line)),j.length?{mode:"stack",name:a.name,message:a.message,url:document.location.href,stack:j,useragent:navigator.userAgent}:null}function l(a){for(var b,c=a.stacktrace,f=/ line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,g=c.split("\n"),h=[],i=0,j=g.length;j>i;i+=2)if(b=f.exec(g[i])){var k={line:+b[1],column:+b[2],func:b[3]||b[4],args:b[5]?b[5].split(","):[],url:b[6]};if(!k.func&&k.line&&(k.func=d(k.url,k.line)),k.line)try{k.context=e(k.url,k.line)}catch(l){}k.context||(k.context=[g[i+1]]),h.push(k)}return h.length?{mode:"stacktrace",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent}:null}function m(a){var b=a.message.split("\n");if(b.length<4)return null;var f,i,j,k,l=/^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,m=/^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,n=/^\s*Line (\d+) of function script\s*$/i,o=[],p=document.getElementsByTagName("script"),q=[];for(i in p)p.hasOwnProperty(i)&&!p[i].src&&q.push(p[i]);for(i=2,j=b.length;j>i;i+=2){var r=null;if(f=l.exec(b[i]))r={url:f[2],func:f[3],line:+f[1]};else if(f=m.exec(b[i])){r={url:f[3],func:f[4]};var s=+f[1],t=q[f[2]-1];if(t&&(k=c(r.url))){k=k.join("\n");var u=k.indexOf(t.innerText);u>=0&&(r.line=s+k.substring(0,u).split("\n").length)}}else if(f=n.exec(b[i])){var v=window.location.href.replace(/#.*$/,""),w=f[1],x=new RegExp(g(b[i+1]));k=h(x,[v]),r={url:v,line:k?k.line:w,func:""}}if(r){r.func||(r.func=d(r.url,r.line));var y=e(r.url,r.line),z=y?y[Math.floor(y.length/2)]:null;r.context=y&&z.replace(/^\s*/,"")===b[i+1].replace(/^\s*/,"")?y:[b[i+1]],o.push(r)}}return o.length?{mode:"multiline",name:a.name,message:b[0],url:document.location.href,stack:o,useragent:navigator.userAgent}:null}function n(a,b,c,f){var g={url:b,line:c};if(g.url&&g.line){a.incomplete=!1,g.func||(g.func=d(g.url,g.line)),g.context||(g.context=e(g.url,g.line));var h=/ '([^']+)' /.exec(f);if(h&&(g.column=i(h[1],g.url,g.line)),a.stack.length>0&&a.stack[0].url===g.url){if(a.stack[0].line===g.line)return!1;if(!a.stack[0].line&&a.stack[0].func===g.func)return a.stack[0].line=g.line,a.stack[0].context=g.context,!1}return a.stack.unshift(g),a.partial=!0,!0}return a.incomplete=!0,!1}function o(a,b){for(var c,e,f,g=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,h=[],k={},l=!1,m=o.caller;m&&!l;m=m.caller)if(m!==p&&m!==v){if(e={url:null,func:UNKNOWN_FUNCTION,line:null,column:null},m.name?e.func=m.name:(c=g.exec(m.toString()))&&(e.func=c[1]),f=j(m)){e.url=f.url,e.line=f.line,e.func===UNKNOWN_FUNCTION&&(e.func=d(e.url,e.line));var q=/ '([^']+)' /.exec(a.message||a.description);q&&(e.column=i(q[1],f.url,f.line))}k[""+m]?l=!0:k[""+m]=!0,h.push(e)}b&&h.splice(0,b);var r={mode:"callers",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent};return n(r,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),r}function p(a,b){var c=null;b=null==b?0:+b;try{if(c=l(a))return c}catch(d){if(r)throw d}try{if(c=k(a))return c}catch(d){if(r)throw d}try{if(c=m(a))return c}catch(d){if(r)throw d}try{if(c=o(a,b+1))return c}catch(d){if(r)throw d}return{mode:"failed"}}function q(a){a=(null==a?0:+a)+1;try{throw new Error}catch(b){return p(b,a+1)}}var r=!1,s={},t=a.remoteFetching,u=a.linesOfContext,v=a.tracekitReport;return p.augmentStackTraceWithInitialElement=n,p.guessFunctionName=d,p.gatherContext=e,p.ofCaller=q,p}function Notifier(a){_topLevelNotifier=_topLevelNotifier||this;var b=window.location.protocol;0!==b.indexOf("http")&&(b="https:");var c=b+"//"+Notifier.DEFAULT_ENDPOINT;this.options={enabled:!0,endpoint:c,environment:"production",scrubFields:Util.copy(Notifier.DEFAULT_SCRUB_FIELDS),checkIgnore:null,logLevel:Notifier.DEFAULT_LOG_LEVEL,reportLevel:Notifier.DEFAULT_REPORT_LEVEL,uncaughtErrorLevel:Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL,payload:{}},this.lastError=null,this.plugins={},this.parentNotifier=a,this.logger=function(){if(window.console&&"function"==typeof window.console.log){var a=["Rollbar:"].concat(Array.prototype.slice.call(arguments,0));window.console.log(a)}},a&&(a.hasOwnProperty("shimId")?a.notifier=this:(this.logger=a.logger,this.configure(a.options)))}function _wrapNotifierFn(a,b){return function(){var c=b||this;try{return a.apply(c,arguments)}catch(d){c&&c.logger(d)}}}function _guessErrorClass(a){if(!a)return["Unknown error. There was no error message to display.",""];var b=a.match(ERR_CLASS_REGEXP),c="(unknown)";return b&&(c=b[b.length-1],a=a.replace((b[b.length-2]||"")+c+":",""),a=a.replace(/(^[\s]+|[\s]+$)/g,"")),[c,a]}function _payloadProcessorTimer(a){for(var b;b=window._rollbarPayloadQueue.shift();)_processPayload(b.endpointUrl,b.accessToken,b.payload,b.callback);a||(payloadProcessorTimeout=setTimeout(_payloadProcessorTimer,1e3))}function _processPayload(a,b,c,d){d=d||function(){};var e=(new Date).getTime();e-rateLimitStartTime>=6e4&&(rateLimitStartTime=e,rateLimitPerMinCounter=0);var f=window._globalRollbarOptions.maxItems,g=window._globalRollbarOptions.itemsPerMinute,h=function(){return!c.ignoreRateLimit&&f>=1&&rateLimitCounter>=f},i=function(){return!c.ignoreRateLimit&&g>=1&&rateLimitPerMinCounter>=g};return h()?(d(new Error(f+" max items reached")),void 0):i()?(d(new Error(g+" items per minute reached")),void 0):(rateLimitCounter++,rateLimitPerMinCounter++,h()&&_topLevelNotifier._log(_topLevelNotifier.options.uncaughtErrorLevel,"maxItems has been hit. Ignoring errors for the remainder of the current page load.",null,{maxItems:f},null,!1,!0),c.ignoreRateLimit&&delete c.ignoreRateLimit,XHR.post(a,b,c,function(a,b){return a?d(a):d(null,b)}),void 0)}function _rollbarWindowOnError(a,b,c){!c[4]&&window._rollbarWrappedError&&(c[4]=window._rollbarWrappedError,window._rollbarWrappedError=null),globalNotifier.uncaughtError.apply(globalNotifier,c),b&&b.apply(window,c)}function _extendListenerPrototype(a,b){if(b.hasOwnProperty&&b.hasOwnProperty("addEventListener")){var c=b.addEventListener;b.addEventListener=function(b,d,e){c.call(this,b,a.wrap(d),e)};var d=b.removeEventListener;b.removeEventListener=function(a,b,c){d.call(this,a,b._wrapped||b,c)}}}var setupCustomJSON=function(JSON){function f(a){return 10>a?"0"+a:a}function quote(a){return escapable.lastIndex=0,escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return"string"==typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function str(a,b){var c,d,e,f,g,h=gap,i=b[a];switch(i&&"object"==typeof i&&"function"==typeof i.toJSON&&(i=i.toJSON(a)),"function"==typeof rep&&(i=rep.call(b,a,i)),typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";if(gap+=indent,g=[],"[object Array]"===Object.prototype.toString.apply(i)){for(f=i.length,c=0;f>c;c+=1)g[c]=str(c,i)||"null";return e=0===g.length?"[]":gap?"[\n"+gap+g.join(",\n"+gap)+"\n"+h+"]":"["+g.join(",")+"]",gap=h,e}if(rep&&"object"==typeof rep)for(f=rep.length,c=0;f>c;c+=1)"string"==typeof rep[c]&&(d=rep[c],e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));return e=0===g.length?"{}":gap?"{\n"+gap+g.join(",\n"+gap)+"\n"+h+"}":"{"+g.join(",")+"}",gap=h,e}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;"function"!=typeof JSON.stringify&&(JSON.stringify=function(a,b,c){var d;if(gap="",indent="","number"==typeof c)for(d=0;c>d;d+=1)indent+=" ";else"string"==typeof c&&(indent=c);if(rep=b,b&&"function"!=typeof b&&("object"!=typeof b||"number"!=typeof b.length))throw new Error("JSON.stringify");return str("",{"":a})}),"function"!=typeof JSON.parse&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&"object"==typeof e)for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),void 0!==d?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})},UNKNOWN_FUNCTION="?",Util={merge:function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!0;for("object"!=typeof g&&"function"!=typeof g&&(g={});i>h;h++)if(null!==(a=arguments[h]))for(b in a)a.hasOwnProperty(b)&&(c=g[b],d=a[b],g!==d&&(j&&d&&(d.constructor==Object||(e=d.constructor==Array))?(e?(e=!1,f=[]):f=c&&c.constructor==Object?c:{},g[b]=Util.merge(f,d)):void 0!==d&&(g[b]=d)));return g},copy:function(a){var b;return"object"==typeof a&&(a.constructor==Object?b={}:a.constructor==Array&&(b=[])),Util.merge(b,a),b},parseUriOptions:{strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}},parseUri:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.parseUri() received invalid input");for(var b=Util.parseUriOptions,c=b.parser[b.strictMode?"strict":"loose"].exec(a),d={},e=14;e--;)d[b.key[e]]=c[e]||"";return d[b.q.name]={},d[b.key[12]].replace(b.q.parser,function(a,c,e){c&&(d[b.q.name][c]=e)}),d},sanitizeUrl:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.sanitizeUrl() received invalid input");var b=Util.parseUri(a);return""===b.anchor&&(b.source=b.source.replace("#","")),a=b.source.replace("?"+b.query,"")},traverse:function(a,b){var c,d,e,f="object"==typeof a,g=[];if(f)if(a.constructor===Object)for(c in a)a.hasOwnProperty(c)&&g.push(c);else if(a.constructor===Array)for(e=0;e<a.length;++e)g.push(e);for(e=0;e<g.length;++e)c=g[e],d=a[c],f="object"==typeof d,a[c]=f?null===d?b(c,d):d.constructor===Object?Util.traverse(d,b):d.constructor===Array?Util.traverse(d,b):b(c,d):b(c,d);return a},redact:function(a){return a=String(a),new Array(a.length+1).join("*")},uuid4:function(){var a=(new Date).getTime(),b="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(b){var c=(a+16*Math.random())%16|0;return a=Math.floor(a/16),("x"==b?c:7&c|8).toString(16)});return b}},RollbarJSON={};setupCustomJSON(RollbarJSON);var XHR={XMLHttpFactories:[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],createXMLHTTPObject:function(){var a,b=!1,c=XHR.XMLHttpFactories,d=c.length;for(a=0;d>a;a++)try{b=c[a]();break}catch(e){}return b},post:function(a,b,c,d){if("object"!=typeof c)throw new Error("Expected an object to POST");c=RollbarJSON.stringify(c),d=d||function(){};var e=XHR.createXMLHTTPObject();if(e)try{try{var f=function(){try{f&&4===e.readyState&&(f=void 0,200===e.status?d(null,RollbarJSON.parse(e.responseText)):"number"==typeof e.status&&e.status>=400&&e.status<600?d(new Error(e.status.toString())):d(new Error))}catch(a){var b;b="object"==typeof a&&a.stack?a:new Error(a),d(b)}};e.open("POST",a,!0),e.setRequestHeader&&(e.setRequestHeader("Content-Type","application/json"),e.setRequestHeader("X-Rollbar-Access-Token",b)),e.onreadystatechange=f,e.send(c)}catch(g){if("undefined"!=typeof XDomainRequest){var h=function(){d(new Error)},i=function(){d(new Error)},j=function(){d(null,RollbarJSON.parse(e.responseText))};e=new XDomainRequest,e.onprogress=function(){},e.ontimeout=h,e.onerror=i,e.onload=j,e.open("POST",a,!0),e.send(c)}}}catch(k){d(k)}}};Notifier.NOTIFIER_VERSION="1.1.9",Notifier.DEFAULT_ENDPOINT="api.rollbar.com/api/1/",Notifier.DEFAULT_SCRUB_FIELDS=["passwd","password","secret","confirm_password","password_confirmation"],Notifier.DEFAULT_LOG_LEVEL="debug",Notifier.DEFAULT_REPORT_LEVEL="debug",Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL="warning",Notifier.DEFAULT_ITEMS_PER_MIN=60,Notifier.DEFAULT_MAX_ITEMS=0,Notifier.LEVELS={debug:0,info:1,warning:2,error:3,critical:4},window._rollbarPayloadQueue=[],window._globalRollbarOptions={startTime:(new Date).getTime(),maxItems:Notifier.DEFAULT_MAX_ITEMS,itemsPerMinute:Notifier.DEFAULT_ITEMS_PER_MIN};var TK=computeStackTraceWrapper({remoteFetching:!1,linesOfContext:3}),_topLevelNotifier;Notifier._generateLogFn=function(a){return _wrapNotifierFn(function(){var b=this._getLogArgs(arguments);return this._log(a||b.level||this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,b.message,b.err,b.custom,b.callback)})},Notifier.prototype._getLogArgs=function(a){for(var b,c,d,e,f,g,h,i=this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,j=0;j<a.length;++j)h=a[j],g=typeof h,"string"===g?c=h:"function"===g?f=_wrapNotifierFn(h,this):h&&"object"===g&&("Date"===h.constructor.name?b=h:h instanceof Error||h.prototype===Error.prototype||h.hasOwnProperty("stack")?d=h:e=h);return{level:i,message:c,err:d,custom:e,callback:f}},Notifier.prototype._route=function(a){var b=this.options.endpoint,c=/\/$/.test(b),d=/^\//.test(a);return c&&d?a=a.substring(1):c||d||(a="/"+a),b+a},Notifier.prototype._processShimQueue=function(a){for(var b,c,d,e,f,g,h,i={};c=a.shift();)b=c.shim,d=c.method,e=c.args,f=b.parentShim,h=i[b.shimId],h||(f?(g=i[f.shimId],h=new Notifier(g)):h=this,i[b.shimId]=h),h[d]&&"function"==typeof h[d]&&h[d].apply(h,e)},Notifier.prototype._buildPayload=function(a,b,c,d,e){var f=this.options.accessToken,g=this.options.environment,h=Util.copy(this.options.payload),i=Util.uuid4();if(void 0===Notifier.LEVELS[b])throw new Error("Invalid level");if(!c&&!d&&!e)throw new Error("No message, stack info or custom data");var j={environment:g,endpoint:this.options.endpoint,uuid:i,level:b,platform:"browser",framework:"browser-js",language:"javascript",body:this._buildBody(c,d,e),request:{url:window.location.href,query_string:window.location.search,user_ip:"$remote_ip"},client:{runtime_ms:a.getTime()-window._globalRollbarOptions.startTime,timestamp:Math.round(a.getTime()/1e3),javascript:{browser:window.navigator.userAgent,language:window.navigator.language,cookie_enabled:window.navigator.cookieEnabled,screen:{width:window.screen.width,height:window.screen.height},plugins:this._getBrowserPlugins()}},server:{},notifier:{name:"rollbar-browser-js",version:Notifier.NOTIFIER_VERSION}};h.body&&delete h.body;var k={access_token:f,data:Util.merge(j,h)};return this._scrub(k.data),k},Notifier.prototype._buildBody=function(a,b,c){var d;return d=b&&"failed"!==b.mode?this._buildPayloadBodyTrace(a,b,c):this._buildPayloadBodyMessage(a,c)},Notifier.prototype._buildPayloadBodyMessage=function(a,b){a||(a=b?RollbarJSON.stringify(b):"");var c={body:a};return b&&(c.extra=Util.copy(b)),{message:c}},Notifier.prototype._buildPayloadBodyTrace=function(a,b,c){var d=_guessErrorClass(b.message),e=b.name||d[0],f=d[1],g={exception:{"class":e,message:f}};if(a&&(g.exception.description=a||"uncaught exception"),b.stack){var h,i,j,k,l,m,n,o;for(g.frames=[],n=0;n<b.stack.length;++n)h=b.stack[n],i={filename:h.url?Util.sanitizeUrl(h.url):"(unknown)",lineno:h.line||null,method:h.func&&"?"!==h.func?h.func:"[anonymous]",colno:h.column},j=k=l=null,m=h.context?h.context.length:0,m&&(o=Math.floor(m/2),k=h.context.slice(0,o),j=h.context[o],l=h.context.slice(o)),j&&(i.code=j),(k||l)&&(i.context={},k&&k.length&&(i.context.pre=k),l&&l.length&&(i.context.post=l)),h.args&&(i.args=h.args),g.frames.push(i);return c&&(g.extra=Util.copy(c)),{trace:g}}return this._buildPayloadBodyMessage(e+": "+f,c)},Notifier.prototype._getBrowserPlugins=function(){if(!this._browserPlugins){var a,b,c=window.navigator.plugins||[],d=c.length,e=[];for(b=0;d>b;++b)a=c[b],e.push({name:a.name,description:a.description});this._browserPlugins=e}return this._browserPlugins},Notifier.prototype._scrub=function(a){function b(a,b,c,d,e,f){return b+Util.redact(f)}function c(a){var c;if("string"==typeof a)for(c=0;c<h.length;++c)a=a.replace(h[c],b);return a}function d(a,b){var c;for(c=0;c<g.length;++c)if(g[c].test(a)){b=Util.redact(b);break}return b}function e(a,b){var e=d(a,b);return e===b?c(e):e}var f=this.options.scrubFields,g=this._getScrubFieldRegexs(f),h=this._getScrubQueryParamRegexs(f);return Util.traverse(a,e),a},Notifier.prototype._getScrubFieldRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp(b,"i"));return c},Notifier.prototype._getScrubQueryParamRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp("("+b+"=)([^&\\n]+)","igm"));return c},Notifier.prototype._urlIsWhitelisted=function(a){var b,c,d,e,f,g,h,i,j,k;try{if(b=this.options.hostWhiteList,c=a.data.body.trace,!b||0===b.length)return!0;if(!c)return!0;for(h=b.length,f=c.frames.length,j=0;f>j;j++){if(d=c.frames[j],e=d.filename,"string"!=typeof e)return!0;for(k=0;h>k;k++)if(g=b[k],i=new RegExp(g),i.test(e))return!0}}catch(l){return this.configure({hostWhiteList:null}),this.error("Error while reading your configuration's hostWhiteList option. Removing custom hostWhiteList.",l),!0}return!1},Notifier.prototype._messageIsIgnored=function(a){var b,c,d,e,f,g,h;try{if(f=!1,d=this.options.ignoredMessages,h=a.data.body.trace,!d||0===d.length)return!1;if(!h)return!1;for(b=h.exception.message,e=d.length,c=0;e>c&&(g=new RegExp(d[c],"gi"),!(f=g.test(b)));c++);}catch(i){this.configure({ignoredMessages:null}),this.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return f},Notifier.prototype._enqueuePayload=function(a,b,c,d){var e={callback:d,accessToken:this.options.accessToken,endpointUrl:this._route("item/"),payload:a},f=function(){if(d){var a="This item was not sent to Rollbar because it was ignored. This can happen if a custom checkIgnore() function was used or if the item's level was less than the notifier' reportLevel. See https://rollbar.com/docs/notifier/rollbar.js/configuration for more details.";d(null,{err:0,result:{id:null,uuid:null,message:a}})}};if(this._internalCheckIgnore(b,c,a))return f(),void 0;try{if(this.options.checkIgnore&&"function"==typeof this.options.checkIgnore&&this.options.checkIgnore(b,c,a))return f(),void 0}catch(g){this.configure({checkIgnore:null}),this.error("Error while calling custom checkIgnore() function. Removing custom checkIgnore().",g)}if(this._urlIsWhitelisted(a)&&!this._messageIsIgnored(a)){if(this.options.verbose){if(a.data&&a.data.body&&a.data.body.trace){var h=a.data.body.trace,i=h.exception.message;this.logger(i)}this.logger("Sending payload -",e)}"function"==typeof this.options.logFunction&&this.options.logFunction(e);try{"function"==typeof this.options.transform&&this.options.transform(a)}catch(g){this.configure({transform:null}),this.error("Error while calling custom transform() function. Removing custom transform().",g)}this.options.enabled&&window._rollbarPayloadQueue.push(e)}},Notifier.prototype._internalCheckIgnore=function(a,b,c){var d=b[0],e=Notifier.LEVELS[d]||0,f=Notifier.LEVELS[this.options.reportLevel]||0;if(f>e)return!0;var g=this.options?this.options.plugins:{};return g&&g.jquery&&g.jquery.ignoreAjaxErrors&&c.body.message?c.body.messagejquery_ajax_error:!1},Notifier.prototype._log=function(a,b,c,d,e,f,g){var h=null;if(c){if(h=c._tkStackTrace?c._tkStackTrace:TK(c),c===this.lastError)return;this.lastError=c}var i=this._buildPayload(new Date,a,b,h,d);g&&(i.ignoreRateLimit=!0),this._enqueuePayload(i,f?!0:!1,[a,b,c,d],e)},Notifier.prototype.log=Notifier._generateLogFn(),Notifier.prototype.debug=Notifier._generateLogFn("debug"),Notifier.prototype.info=Notifier._generateLogFn("info"),Notifier.prototype.warn=Notifier._generateLogFn("warning"),Notifier.prototype.warning=Notifier._generateLogFn("warning"),Notifier.prototype.error=Notifier._generateLogFn("error"),Notifier.prototype.critical=Notifier._generateLogFn("critical"),Notifier.prototype.uncaughtError=_wrapNotifierFn(function(a,b,c,d,e,f){if(f=f||null,e&&e.stack)return this._log(this.options.uncaughtErrorLevel,a,e,f,null,!0),void 0;if(b&&b.stack)return this._log(this.options.uncaughtErrorLevel,a,b,f,null,!0),void 0;var g={url:b||"",line:c};g.func=TK.guessFunctionName(g.url,g.line),g.context=TK.gatherContext(g.url,g.line);var h={mode:"onerror",message:a||"uncaught exception",url:document.location.href,stack:[g],useragent:navigator.userAgent};e&&(h=e._tkStackTrace||TK(e));var i=this._buildPayload(new Date,this.options.uncaughtErrorLevel,a,h);this._enqueuePayload(i,!0,[this.options.uncaughtErrorLevel,a,b,c,d,e])}),Notifier.prototype.global=_wrapNotifierFn(function(a){a=a||{},Util.merge(window._globalRollbarOptions,a),void 0!==a.maxItems&&(rateLimitCounter=0),void 0!==a.itemsPerMinute&&(rateLimitPerMinCounter=0)}),Notifier.prototype.configure=_wrapNotifierFn(function(a){Util.merge(this.options,a)}),Notifier.prototype.scope=_wrapNotifierFn(function(a){var b=new Notifier(this);return Util.merge(b.options.payload,a),b}),Notifier.prototype.wrap=function(a,b){var c;if(c="function"==typeof b?b:function(){return b||{}},"function"!=typeof a)return a;if(a._isWrap)return a;if(!a._wrapped){a._wrapped=function(){try{a.apply(this,arguments)}catch(b){throw b.stack||(b._tkStackTrace=TK(b)),b._rollbarContext=c(),b._rollbarContext._wrappedSource=a.toString(),window._rollbarWrappedError=b,b}},a._wrapped._isWrap=!0;for(var d in a)a.hasOwnProperty(d)&&(a._wrapped[d]=a[d])}return a._wrapped};var ERR_CLASS_REGEXP=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): "),payloadProcessorTimeout;Notifier.processPayloads=function(a){(!payloadProcessorTimeout||a)&&_payloadProcessorTimer(a)};var rateLimitStartTime=(new Date).getTime(),rateLimitCounter=0,rateLimitPerMinCounter=0,globalNotifier=new Notifier;window._rollbarWrappedError=null,globalNotifier.init=function(a){if(this.configure(a),a.captureUncaught){var b=window.onerror;window.onerror=function(){var a=Array.prototype.slice.call(arguments,0);_rollbarWindowOnError(globalNotifier,b,a)};var c,d,e=["EventTarget","Window","Node","ApplicationCache","AudioTrackList","ChannelMergerNode","CryptoOperation","EventSource","FileReader","HTMLUnknownElement","IDBDatabase","IDBRequest","IDBTransaction","KeyOperation","MediaController","MessagePort","ModalWindow","Notification","SVGElementInstance","Screen","TextTrack","TextTrackCue","TextTrackList","WebSocket","WebSocketWorker","Worker","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestUpload"];for(c=0;c<e.length;++c)d=e[c],window[d]&&window[d].prototype&&_extendListenerPrototype(this,window[d].prototype)}Notifier.processPayloads()},module.exports=globalNotifier});
/*
	App configuration
*/

define('app',[
	"libs/core",
	"helpers/menu",
	"helpers/locale",
	"helpers/theme",
	"libs/rollbar"
], function(core, menu, locale, theme, tracker){

	//webix.codebase = "libs/webix/";
	//CKEditor requires full path
	webix.codebase = document.location.href.split("#")[0].replace("index.html","")+"libs/webix/";

	if(!webix.env.touch && webix.ui.scrollSize && webix.CustomScroll)
		webix.CustomScroll.init();


/*	if (webix.production)
		tracker.init({
		//	accessToken: '650b007d5d794bb68d056584451a57a8',
			captureUncaught: true,
			source_map_enabled: true,
			code_version:"0.8.0",
			payload: {
				environment: 'production'
			}
		}); */

	//configuration
	var app = core.create({
		id:			"penta",
		name:		"penta",
		version:	"0.1",
		debug:		true,
		start:		"/app/main"
	});

	app.use(menu);
	app.use(locale);
	app.use(theme);

	return app;
});

define(
'views/menus/sidebar',[],function(){
	return {
		$ui:{
			view: "sidemenu",
			id: "app:menu",
			width: 200,
			position: "left",
			state:function(state){
				var toolbarHeight = $$("toolbar").$height;
				state.top = toolbarHeight;
				state.height -= toolbarHeight;
			},
			body:{
				view:"list",
				id: "app:menu:list", 
				borderless:true,
				scroll: false,
				template: "<span class='webix_icon fa-#icon#'></span> #value#",
                on:{
					onItemClick:function(id){
						if (id == "logout") {
	                        webix.confirm({
	                            ok: "Yes",
	                            cancel: "No",
	                            text: "Are you sure to logout?",
	                            callback: function(result) {
	                                if (result == true) {
	                                    var str = location.pathname;
	                                    parent.location.href =  str.replace('index.php','') + "logout.php";
	                                }
	                            }
	                        });    
						} else {
							this.$scope.show("./"+id);
						}
						$$("app:menu").hide();   
					}				
                },
				url: "server/masterdata.php?id=GETPROGRAMMENU",
				select:true,
				type:{
					height: 40
				}
			}					
		}
	};

});

// icon button with count marker
webix.protoUI({
	name:"icon",
	$skin:function(){
		this.defaults.height = webix.skin.$active.inputHeight;
	},
	defaults:{
		template:function(obj){
			var html = "<button style='height:100%;width:100%;line-height:"+obj.aheight+"px' class='webix_icon_button'>";
			html += "<span class='webix_icon fa-"+obj.icon+"'></span>";
			if(obj.value)
				html += "<span class='webix_icon_count'>"+obj.value+"</span>";
			html += "</button>";
			return html;
		},
		width:33
	},
	_set_inner_size:function(){

	}
}, webix.ui.button);
define("views/webix/icon", function(){});

define('views/app',[
	"views/menus/sidebar",
	"views/webix/icon"
],function(menu){

	//Top toolbar
	var mainToolbar = {
		view: "toolbar",
		id:"toolbar",
		css:"header",
		height: 50,
		elements:[
            // { view:"button", type: "iconTop", icon: "bars", 
            //     width: 40, align: "center", css: "app_button", click: function() {
			// 		if( $$("app:menu").config.hidden){
			// 			$$("app:menu").show();
			// 		}
			// 		else
			// 			$$("app:menu").hide();                
			// 	}
            // },
            {view: "label", label: "<img width='192' height='40' src='assets/imgs/logo.png' /></a>", width: 200},
            // { view: "label", label: "PENDAFTARAN ONLINE"}
		]
	};

	var body = {
		rows:[
			{
				view: "scrollview", scroll: false, //"native-y",
				body:{ cols:[{ $subview:true}]  }
			}
		]
	};

	var layout = {
		rows:[
			mainToolbar,
			{
				cols:[
					body
				]
			}
		]
	};

	return {
		$ui:layout,
		$menu:"app:menu",
		$oninit:function(view, scope){
			scope.ui(menu.$ui);
		}
	}
});

define('views/batal',[],function(){


	var layout = {
		type:"clean",
		rows: [
			{ header:"Pembatalan Perjanjian", body:{
				view:"form", 
				autoheight: false, 
				height: 100, 
				id:"DaftarHeader", 
				scroll: true, 
				margin: 4, 
					elements:[
						{
							cols: [
								// { view:"text", id:"PASIENID", name:"PASIENID", label: "NIK/Passport", labelWidth: 104, width:270 },
								{ view:"text", id:"PASIENID", name:"PASIENID", label: "NIK/Passport/No. Asuransi/BPJS Penta ", labelPosition: "top", width:260 },
								{ view: "button", type: "iconButton", id:"CHECK_RM", icon:"check", width:76, label:"Check",
									click:function(){
										var norm = $$("PASIENID").getValue();
										if (norm) {
                                        	var grid = $$("DataAntrian");
											grid.hide();
	                                        webix.ajax("server/masterdata.php?id=GETRESERVATION&norm="+norm, function(text){
	                                            if (text != "[]") {
	                                            	$$("NOT_FOUND_LABEL").hide();
	                                            	grid.clearAll();
	                                            	grid.show();
	                                            	grid.load("server/masterdata.php?id=GETRESERVATION&norm="+norm);
	                                            } else {
	                                            	$$("NOT_FOUND_LABEL").show();
	                                            	grid.hide();
	                                            }
	                                        })
										}
									}
								}, 
								{}
							]
						},
						{ view: "label", label:"Appointment not found/Data perjanjian tidak ditemukan", id:"NOT_FOUND_LABEL", css: "warnLabel", hidden:true},
			            {
			                view:"datatable", 
			                hidden:true,
			                id:"DataAntrian", 
			                height:200, 
			                select:true, 
			                editable:false, 
			                navigation: true, 
			                tooltip:true,
			                rightSplit:1,
			                columns:[
			                   // {id:"nomor", header:{text:"No.", css:{'text-align':'center'}}, css:{'text-align':'center'}, width:35},
			                    {id:"RESERVDATE", header:"Date", sort:"string", width:80, format:webix.i18n.dateFormatStr},
			                    // {id:"nomorrm", header:"No. RM", css:{'text-align':'center'}, sort:"string", width:80},
			                    {id:"DEPT", header: "Location", sort:"string", width:80},
			                    {id:"GUDANG", header: "Policlinic", sort:"string", width:120},
			                    {id:"NAMAPASIEN", header: "Name", sort:"string", width:150},
			                    {id:"ALAMAT", header: "Address", sort:"string", width:200},
			                    {id:"RESERVNO", header:{text:"Appt. #", css:{'text-align':'right'}}, sort:"string", css:{'text-align':'right'}, width:90},
			                    {id:"MEDICALRESERVID", header:"", hidden:true},
			                    {id:"select", header:"Action",
			                        template:function(obj){ 
			                            return "<div class='webix_el_button'><button class='webixtype_base'> Cancel</button></div>";
			                        }
			                    }
			                ],
			                onClick:{
			                    "webixtype_base":function(ev,id,html){
                                    var grid = $$("DataAntrian");
                                    var item = grid.getItem(id);
		                            webix.confirm({
		                                title: "K O N F I R M A S I",
		                                width: "300px",
		                                text:"Sure to cancel your appointment/Batalkan nomor antrian ini?", 
		                                ok:"Ya", cancel:"Tidak",
		                                callback:function(res){
		                                    if(res){
						              			webix.ajax("server/masterdata.php?id=DELETERESERVATION&reservid="+item.MEDICALRESERVID, function(text){
						              				if (text) {
						              					webix.message({ type:"success", text:text});	
		                                                webix.UIManager.setFocus($$('PASIENID'));
	                                                	$$("PASIENID").setValue("");
						              					grid.hide();
						              				} else {
														webix.message({ type:"error", text:"Terjadi kesalahan, antrian tidak bisa dibatalkan. Cobalah beberapa saat lagi"});						              					
						              				}
						                        });
		                                    }
		                                }
		                            });
			                    }
			                },
			                on:{
			                    onBeforeLoad:function(){
			                       this.showOverlay("Loading...");
			                    },
			                    onAfterLoad:function(){
			                        this.hideOverlay();
			                    }
			                }
			            }
					],
					rules:{
						$obj:function(data){
							// if (!data.CUSTID){
							// 	webix.message({ type:"error", text:"Silakan masukkan nama customer"});
							// 	return false;
							// }
							// if (!data.SALESPERSONID){
							// 	webix.message({ type:"error", text:"Silakan masukkan nama sales"});
							// 	return false;
							// }
							return true;
						}
				    }        
				}
			},
		]
    };

	return { $ui:layout };

});

define('views/main',[],function(){

	var html2 = "";
	var location = webix.storage.session.get('location');
	var computerid = webix.storage.session.get('computerid');
	if (location == "DENPASAR") {
		location = "DPS";
	}
	if (location == "MGS") {
		location = "MANGGIS";
	}

	function checkPasien() {
		$$("GUDANG").define("options","server/masterdata.php?id=OPTPOLI&dept="+location);
		$$("GUDANG").refresh();
		$$("GUDANG").setValue("-1");
		$$("NOT_VALID_NUMBER").hide();
		var norm = $$("PASIENID").getValue();
		norm = encodeURIComponent(norm);
		webix.ajax("server/masterdata.php?id=ISVALIDNUMBER&norm="+norm, function(text){
			// console.log(text);
			rdata = JSON.parse(text);
			if (rdata.isvalid) {
				webix.ajax("server/masterdata.php?id=GETANTREANLIST&norm="+norm, function(text){
					// console.log(text);
					if (text != "[]") {
						rdata = JSON.parse(text);
						if (rdata[0].RESERVATIONID*1 > 0) {
							$$("RESERV_TEMPLATE").show();
                            var timestamp = new Date().getTime();
							if (rdata[0].SALESID > 0) {
								// html2 = '<table style="width: 100%; font-family: Calibri, Helvetica, sans-serif;">';
								// html2 += '<tr><td style="text-align:center; font-size:14pt; text-decoration: underline;" colspan="3">Nomor Antrean</td></tr>';
								// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif; font-size:100pt;" colspan="3">'+rdata[0].NOANTREAN+'</td></tr>';
								// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata[0].SALESID+'.png?'+timestamp+'"/></td></tr>';
								// // html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="server/qrcode.php?id='+rdata[0].SALESID+'&'+timestamp+'"/></td></tr>';
								// html2 += '<tr><td style="width:48%; text-align:right; font-size:10pt;">Sisa Antrean: '+rdata[0].SISAANTREAN+'</td>';
								// html2 += '<td style="width:4%; text-align:right; font-size:10pt;"></td>';
								// html2 += '<td style="width:48%; text-align:left; font-size:10pt;">Antrean Dipanggil: '+rdata[0].ANTREANDIPANGGIL+'</td></tr>';
								// html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda merupakan pasien reservasi di '+rdata[0].GUDANG+'</td></tr>';
								// html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda akan dipanggil dalam waktu: '+rdata[0].TIMETOCALL+' menit</td></tr>';
								// html2 += '</table>';
								html2 = '<table style="width: 100%; font-family: Calibri, sans-serif;">';
								html2 += '<tr><td style="text-align:center; font-size:21pt; font-weight: bold; height: 55px;" colspan="3">KLINIK PENTA MEDICA</td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:6pt;" colspan="3"></td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">NOMOR ANTREAN</td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">'+rdata[0].GUDANG+'</td></tr>';
								html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif; font-size:100pt; font-weight: bold;" colspan="3">'+rdata[0].NOANTREAN+'</td></tr>';
								html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata[0].SALESID+'.png?'+timestamp+'"/></td></tr>';
								html2 += '<td style="width:4%; text-align:right; font-size:10pt;"></td>';
								html2 += '<tr><td style="text-align:center; font-size:14pt;" colspan="3">'+rdata[0].ANTREANDATE+'</td></tr>';
								html2 += '<td style="width:4%; text-align:right; font-size:6pt;"></td>';
								html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda merupakan pasien reservasi</td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda akan dipanggil dalam waktu: '+rdata[0].TIMETOCALL+' menit</td></tr>';
								html2 += '</table>';
							} else {
								html2 = '<table style="width: 100%; font-family: Calibri, Helvetica, sans-serif;">';
								html2 += '<tr><td style="text-align:center; font-size:14pt; text-decoration: underline;" colspan="3">Pasien Reservasi</td></tr>';
								html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata[0].SALESID+'.png?'+timestamp+'"/></td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda merupakan pasien reservasi di '+rdata[0].GUDANG+'</td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Anda harus registrasi selambat-lambatnya dalam '+rdata[0].TIMETOCALL+' menit</td></tr>';
								html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="3">Silakan scan barcode dari bukti reservasi untuk registrasi</td></tr>';
								html2 += '</table>';
							}
							// var html = '<table style="border-collapse: collapse; width: 100%;" border="2"><tbody><tr>';
							// html += '<td style="width: 100%; background-color: yellow;">';
							// html += '<div><div style="text-align: center;">&nbsp;</div>';
							// html += '<div style="text-align: center;"><strong><span style="color: #ff0000;">Anda merupakan pasien reservasi di '+rdata[0].GUDANG+', dan sudah teregistrasi dengan nomor: '+rdata[0].SALESNO+'</span></strong></div>';
							// html += '<div style="text-align: center;"><strong><span style="color: #ff0000;">Anda akan dipanggil dalam waktu: '+rdata[0].TIMETOCALL+' menit</span></strong></div>';
							// html += '<div style="text-align: center;">&nbsp;</div></div></td></tr></tbody></table>';
							$$("RESERV_TEMPLATE").setHTML(html2);
							$$("BACK_BUTTON").show();
							if (computerid) {
								$$("PRINT_ANTREAN").show();
							}
							$$("RESERV_TEMPLATE").define("height", window.innerHeight-300);
							$$("RESERV_TEMPLATE").resize();
						} else {
							$$("RESERV_TEMPLATE").show();
                            var timestamp = new Date().getTime();
							// html2 = '<table style="width: 100%; font-family: Arial, Helvetica, sans-serif;">';
							// html2 += '<tr><td style="text-align:center; font-size:14pt; text-decoration: underline;" colspan="3">Nomor Antrean</td></tr>';
							// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif; font-size:100pt;" colspan="3">'+rdata[0].NOANTREAN+'</td></tr>';
							// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata[0].SALESID+'.png?'+timestamp+'"/></td></tr>';
							// // html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="server/qrcode.php?id='+rdata[0].SALESID+'&'+timestamp+'"/></td></tr>';
							// html2 += '<tr><td style="width:48%; text-align:right; font-size:10pt;">Sisa Antrean: '+rdata[0].SISAANTREAN+'</td>';
							// html2 += '<td style="width:4%; text-align:right; font-size:10pt;"></td>';
							// html2 += '<td style="width:48%; text-align:left; font-size:10pt;">Antrean Dipanggil: '+rdata[0].ANTREANDIPANGGIL+'</td></tr>';
							// html2 += '</table>';
							html2 = '<table style="width: 100%; font-family: Calibri, sans-serif;">';
							html2 += '<tr><td style="text-align:center; font-size:21pt; font-weight: bold; height: 55px;" colspan="3">KLINIK PENTA MEDICA</td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:6pt;" colspan="3"></td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">NOMOR ANTREAN</td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">'+rdata[0].GUDANG+'</td></tr>';
							html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif; font-size:100pt; font-weight: bold;" colspan="3">'+rdata[0].NOANTREAN+'</td></tr>';
							html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata[0].SALESID+'.png?'+timestamp+'"/></td></tr>';
							html2 += '<td style="width:4%; text-align:right; font-size:8pt;"></td>';
							html2 += '<tr><td style="text-align:center; font-size:13pt; font-weight: bold;" colspan="3">Sisa Antrean: '+rdata[0].SISAANTREAN+'</td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:13pt; font-weight: bold;" colspan="3">Antrean Dipanggil: '+rdata[0].ANTREANDIPANGGIL+'</td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:14pt;" colspan="3">'+rdata[0].ANTREANDATE+'</td></tr>';
							html2 += '<td style="width:4%; text-align:right; font-size:8pt;"></td>';
							html2 += '<tr><td style="text-align:center; font-size:11pt;" colspan="3">Jika antrean terlewat mohon</td></tr>';
							html2 += '<tr><td style="text-align:center; font-size:11pt;" colspan="3">untuk melakukan pendaftaran ulang</td></tr>';
							html2 += '</table>';
							$$("RESERV_TEMPLATE").setHTML(html2);
							$$("BACK_BUTTON").show();
							if (computerid) {
								$$("PRINT_ANTREAN").show();
							}
							$$("RESERV_TEMPLATE").define("height", window.innerHeight-300);
							$$("RESERV_TEMPLATE").resize();
						}
					} else {
						$$("RESERV_TEMPLATE").hide();
						$$("jenis_antrian").show();
						$$("NAMAPASIEN").show();
						$$("tgllahir_reserv").show();
						$$("kelamin_reserv").show();
						$$("ALAMAT").show();
						$$("patienttype_reserv").show();
						$$("NOTELEPON").show();
						$$("EMAIL").show();
						$$("gudang_reserv").show();
						// Data antrian tidak ditemukan. Cek jika itu pasien reservasi
						$$("NAMAPASIEN").config.readonly = true;
						$$("NAMAPASIEN").refresh();    				
						$$("ALAMAT").config.readonly = true;
						$$("ALAMAT").refresh();    				
						$$("TGLLAHIR").config.readonly = true;
						$$("TGLLAHIR").refresh();    				
						$$("SEX").config.readonly = true;
						$$("SEX").refresh();    				
						$$("PATIENTTYPE").config.disabled = true;
						$$("PATIENTTYPE").refresh();    				
						$$("NOKARTUBPJS").config.readonly = true;
						$$("NOKARTUBPJS").refresh();    				
						$$("NOTELEPON").config.readonly = true;
						$$("NOTELEPON").refresh();    				
						$$("EMAIL").config.readonly = true;
						$$("EMAIL").refresh();    				
						$$("GUDANG").config.disabled = true;
						$$("GUDANG").refresh();    				
						webix.ajax("server/masterdata.php?id=GETRESERVATION&norm="+norm, function(text){
							if (text != "[]") {
								// Jika ada reservasi
								$$("JENISANTREAN").setValue("RESERVASI");
								rdata = JSON.parse(text);
								$$("NAMAPASIEN").setValue(rdata[0].NAMAPASIEN);
								$$("ALAMAT").setValue(rdata[0].ALAMAT);
								$$("TGLLAHIR").setValue(rdata[0].TGLLAHIR);
								$$("SEX").setValue(rdata[0].SEX);
								$$("PATIENTTYPE").setValue(rdata[0].PATIENTTYPE);
								$$("NOKARTUBPJS").setValue(rdata[0].NOKARTUBPJS);
								$$("NOTELEPON").setValue(rdata[0].NOTELEPON);
								$$("EMAIL").setValue(rdata[0].EMAIL);
								$$("DEPT").setValue(rdata[0].DEPT);
								$$("GUDANG").setValue(rdata[0].GUDANG);
								$$("SAVE").show();
							} else {
								webix.ajax("server/masterdata.php?id=GETPASIEN&norm="+norm, function(text){
									if (text != "[]") {
										rdata = JSON.parse(text);
										$$("NAMAPASIEN").setValue(rdata[0].PERUSAHAAN);
										$$("ALAMAT").setValue(rdata[0].ALAMAT1);
										$$("TGLLAHIR").setValue(rdata[0].TGLLAHIR);
										$$("SEX").setValue(rdata[0].SEX);
										if (rdata[0].PATIENTTYPE == "BPJS") {
											$$("JENISANTREAN").setValue("BPJS");
											$$("PATIENTTYPE").setValue(rdata[0].PATIENTTYPE);
										} else {
											$$("JENISANTREAN").setValue("UMUM");
											$$("PATIENTTYPE").setValue("Other");
										}
										$$("NOKARTUBPJS").setValue(rdata[0].PATIENTTYPEIDNO);
										$$("NOKTP").setValue(rdata[0].KITAS);
										$$("NOTELEPON").setValue(rdata[0].TELPON1);
										$$("EMAIL").setValue(rdata[0].EMAIL);
										$$("GUDANG").config.disabled = false;
										$$("GUDANG").refresh();    				
										$$("SAVE").show();
									} else {
										$$("NAMAPASIEN").config.readonly = false;
										$$("NAMAPASIEN").refresh();    				
										$$("ALAMAT").config.readonly = false;
										$$("ALAMAT").refresh();    				
										$$("TGLLAHIR").config.readonly = false;
										$$("TGLLAHIR").refresh();    				
										$$("SEX").config.readonly = false;
										$$("SEX").refresh();    				
										$$("PATIENTTYPE").config.disabled = false;
										$$("PATIENTTYPE").refresh();    				
										$$("NOKARTUBPJS").config.readonly = false;
										$$("NOKARTUBPJS").refresh();    				
										$$("NOTELEPON").config.readonly = false;
										$$("NOTELEPON").refresh();    				
										$$("EMAIL").config.readonly = false;
										$$("EMAIL").refresh();    				
										$$("GUDANG").config.disabled = false;
										$$("GUDANG").refresh();    				
										$$("JENISANTREAN").setValue("DAFTAR BARU");
										$$("NAMAPASIEN").setValue("");
										$$("ALAMAT").setValue("");
										$$("TGLLAHIR").setValue("");
										$$("SEX").setValue("");
										$$("PATIENTTYPE").setValue("");
										$$("NOTELEPON").setValue("");
										$$("EMAIL").setValue("");
										$$("SAVE").show();
									}
								})
							}
						})
					}
				});
			} else {
				$$("NOT_VALID_NUMBER").define("label", rdata.pesan);
				$$("NOT_VALID_NUMBER").refresh();
				$$("NOT_VALID_NUMBER").show();
				$$("RESERV_TEMPLATE").hide();
				$$("jenis_antrian").hide();
				$$("NAMAPASIEN").hide();
				$$("tgllahir_reserv").hide();
				$$("kelamin_reserv").hide();
				$$("ALAMAT").hide();
				$$("patienttype_reserv").hide();
				$$("NO_BPJS").hide();
				$$("NOTELEPON").hide();
				$$("EMAIL").hide();
				$$("gudang_reserv").hide();
				$$("SAVE").hide();
			}
		});
	}

	var layout = {
		type:"clean",
		rows: [
			{ header:"Pendaftaran Pasien", body:{
				view:"form", 
				autoheight: false, 
				height: 100, 
				id:"DaftarHeader", 
				scroll: true, 
				margin: 4, 
					elements:[
	                    { view:"text", label:"", labelPosition: "top", name:"DEPT", id:"DEPT", value: location, width : 100, readonly:true, hidden:true,
							on: {
								onChange: function(newv,oldv) {
									$$("GUDANG").define("options","server/masterdata.php?id=OPTPOLI&dept="+newv);
									$$("GUDANG").refresh();
									$$("GUDANG").setValue("-1");
								}
							}
						},
	                    { view:"text", label:"", labelPosition: "top", name:"COMPUTERID", id:"COMPUTERID", value: computerid, width : 100, readonly:true, hidden:true},
						{ view: "label", label:"Mohon maaf, jam registrasi belum dibuka atau sudah habis", id:"OUT_OF_TIME", css: "warnLabel", hidden:true},
	                    { view:"text", label:"", labelPosition: "top", name:"ANTRIANID", id:"ANTRIANID", width : 100, readonly:true, hidden:true },
						{
							id: "CHECK_RM_PANEL",
							cols: [
								{ view:"text", id:"PASIENID", name:"PASIENID", label: "NIK/No.BPJS/No.Reservasi", labelPosition: "top", required:true,
									on: {
										'onBlur': function(prev_view) {
											var dept = $$("DEPT").getValue();
											webix.ajax("server/masterdata.php?id=GETDEPT&dept="+dept, function(text){
												rdata = JSON.parse(text);
												if (rdata[0].CANREGIST*1 == 0) {
													$$("OUT_OF_TIME").show();
													$$("CHECK_RM_PANEL").hide();
												} else {
													$$("OUT_OF_TIME").hide();
												}
											});
											if (this.getValue()) {
												checkPasien();
											}
										},
										'onFocus': function(cuurent_view,prev_view) {
											var dept = $$("DEPT").getValue();
											webix.ajax("server/masterdata.php?id=GETDEPT&dept="+dept, function(text){
												rdata = JSON.parse(text);
												if (rdata[0].CANREGIST*1 == 0) {
													$$("OUT_OF_TIME").show();
													$$("CHECK_RM_PANEL").hide();
												} else {
													$$("OUT_OF_TIME").hide();
												}
											});
										}
									}
								},
								{ view: "button", type: "iconButton", id:"CHECK_RM", icon:"check", width:76, label:"Check",
									click:function(){
										var dept = $$("DEPT").getValue();
										webix.ajax("server/masterdata.php?id=GETDEPT&dept="+dept, function(text){
											rdata = JSON.parse(text);
											if (rdata[0].CANREGIST*1 == 0) {
												$$("OUT_OF_TIME").show();
												$$("CHECK_RM_PANEL").hide();
											} else {
												$$("OUT_OF_TIME").hide();
											}
										});
										if (this.getValue()) {
											checkPasien();
										}
									}
								}
							]
						},
						{ view: "label", label:"Mohon maaf, jam registrasi sudah habis", id:"NOT_VALID_NUMBER", css: "warnLabel", hidden:true},
						{ 	
							id: "RESERV_TEMPLATE",
							view: "template", 
							autoheight: true,
							hidden:true,
							// borderless: true,
							// url: "server/masterdata.php?id=GETRESERVATION&norm=",
							template: function(obj){
								var html = '<table style="border-collapse: collapse; width: 100%;" border="2"><tbody><tr>';
								html += '<td style="width: 100%; background-color: yellow;">';
								html += '<div><div style="text-align: center;">&nbsp;</div>';
								html += '<div style="text-align: center;"><strong><span style="color: #ff0000;">Mohon lakukan pembatalan jika berhalangan hadir  karena banyak pasien yang menunggu mendapatkan kesempatan berobat</span></strong></div>';
								html += '<div style="text-align: center;">&nbsp;</div></div></td></tr></tbody></table>';
								html2 = '<div class="h-[50%] py-3"><div class="h-[100%] flex items-center justify-center bg-blue-900 rounded-3xl text-gray-100">';
								html2 += '<div class="text-center"><p class="md:text-5xl lg:text-6xl xl:text-7xl mt-3 font-medium tracking-wide" id="POLI UMUM">-</p>';
								html2 += '<hr class="mt-6 border-t-4"><p class="md:text-2xl lg:text-2xl xl:text-2xl mt-6 font-normal tracking-wide">Sisa Antrean Poli Umum</p>';
								html2 += '</div></div></div>';
								return html2;
							},
							type: "html"
						},
						{
							id: "jenis_antrian", 
							hidden:true,
							cols: [
			                    { view:"select", labelWidth: 104, width: 260, label:"Jenis Antrian", name:"JENISANTREAN", id:"JENISANTREAN", required: true, disabled:true,
			                        options:[ 
			                            { id:"UMUM", value:"UMUM" },
			                            { id:"BPJS", value:"BPJS" },
			                            { id:"RESERVASI", value:"RESERVASI"},
			                            { id:"DAFTAR BARU", value:"DAFTAR BARU"}
			                        ],
									on: {
										onChange:function(newv,oldv) {
											// if (newv == "UMUM") {
											// 	$$("PASIENID").define("label", "NIK/No. KTP:" );
											// 	$$("PASIENID").refresh();
											// } else if (newv == "BPJS") {
											// 	$$("PASIENID").define("label", "No. Kartu BPJS:" );
											// 	$$("PASIENID").refresh();
											// } else if (newv == "RESERVASI") {
											// 	$$("PASIENID").define("label", "No. Reservasi (bisa nomor terakhir saja)");
											// 	$$("PASIENID").refresh();
											// } else if (newv == "DAFTAR BARU") {
											// 	$$("PASIENID").define("label", "NIK/No. KTP:" );
											// 	$$("PASIENID").refresh();
											// }
										}

									}									
			                    },                    
								{}
							]
						},
						{ view:"text", name:"NAMAPASIEN", id:"NAMAPASIEN", label: "Nama Anda",  labelWidth: 104, required: true,  hidden:true},
						{
							id: "tgllahir_reserv",
							hidden:true,
							cols: [
			                    { view:"datepicker", name:"TGLLAHIR", id:"TGLLAHIR", labelWidth: 104, width: 240, stringResult: true, label:"Tanggal Lahir", editable:true, required:true},
								{}
							]
						},
						{
							id: "kelamin_reserv", 
							hidden:true,
							cols: [
			                    { view:"select", labelWidth: 104, width: 260, label:"L/P", name:"SEX", id:"SEX", required: true,
			                        options:[ 
			                            { id:"-1", value:"-Pilih/Select-" },
			                            { id:"M", value:"Laki/Male" },
			                            { id:"F", value:"Perempuan/Female"}
			                        ]
			                    },                    
								{}
							]
						},
						{ view:"text", name:"ALAMAT", id:"ALAMAT", label: "Alamat", labelWidth: 104, required: true,  hidden:true},
						{
							id: "patienttype_reserv",
							hidden:true,
							cols: [
			                    { view:"select", labelWidth: 104, width: 240, label:"Payment Type", id: "PATIENTTYPE", name:"PATIENTTYPE", value:"-1", required: true, 
			                        options:[ 
			                            { id:"-1", value:"-Pilih/Select-" },
			                            { id:"BPJS", value:"BPJS" },
			                            { id:"Other", value:"Other/Lainnya"}
			                        ],
					            	on:{
			    						onChange:function(newv,oldv){
			    							newv == 'BPJS' ? $$("NO_BPJS").show() : $$("NO_BPJS").hide();
			                            }
					            	}
			                    },                    
								{}
							]
						},
						{
							id: "NO_BPJS", hidden:true,
							cols: [
                				{ view:"text", label:"No. BPJS", name:"NOKARTUBPJS",  id:"NOKARTUBPJS", labelWidth:104, width: 280 },
                				{ view:"text", label:"No. KTP", name:"NOKTP",  id:"NOKTP", labelWidth:104, width: 280, hidden: true},
                				{}
							]
						},
                		{ view:"text", label:"Tel./Hp", name:"NOTELEPON",  id:"NOTELEPON", labelWidth:104, hidden:true},
                		{ view:"text", label:"Email", name:"EMAIL",  id:"EMAIL", labelWidth:104,  hidden:true},
						{
							id: "gudang_reserv",
							hidden:true,
							cols: [
	                    		{ view:"select", label:"Poli Tujuan", id: "GUDANG", name:"GUDANG", options: "[]", labelWidth: 104, width: 300, required: true,
	                    			on: {
                                        onFocus: function(current_view, prev_view) {
                                        	var dept = $$("DEPT").getValue();
	                    					$$("GUDANG").define("options","server/masterdata.php?id=OPTPOLI&dept="+dept);
	                    					$$("GUDANG").refresh();
                                        }
	                    			}
	                    		},
								{}
							]
						},
						{
							cols: [
								{},
								{ view: "button", type: "iconButton", id:"BACK_BUTTON", icon:"refresh", width: 120, label:"Daftar Lagi", hidden: true,
									click:function(){
										window.location.reload(true);
									}
								}, 
								{ view: "button", type: "iconButton", id:"PRINT_ANTREAN", icon:"print", width: 160, label:"Cetak Nomor Antrean", hidden: true, 
									click:function(){
										//webix.print("RESERV_TEMPLATE");
										var popupWin = window.open('', 'PrintWindow','width=650,height=650,location=no,left=200px');
										popupWin.document.write(html2);
										popupWin.print();
										popupWin.close();
										// var newWin = window.open();
										// newWin.document.open();
										// newWin.document.write(html2); //add your content
										// newWin.document.close();
										window.location.reload(true);
									}
								},
								{}
							]
						},
	                	{ height: 20},
						{
							cols: [
								{},
								{ view: "button", type: "iconButton", id:"SAVE", icon:"save", width:100, label:"Daftar",  hidden:true,
									click:function(){
										var jenisantren = $$("JENISANTREAN").getValue();
										if (jenisantren == "DAFTAR BARU") {
											var form = $$("DaftarHeader");
											if (form.validate()) { 
												$$("SAVE").disable();
												var values = form.getValues();
												var url = "server/masterdata.php?id=NEWREGISTRATIONFORM";
												webix.ajax().post(url, values, function(text) {
													if (text) {
														// webix.message({ type:"success", text:text});	
														webix.UIManager.setFocus($$('PASIENID'));
														$$("NAMAPASIEN").setValue("");
														$$("TGLLAHIR").setValue("");
														$$("SEX").setValue("");
														$$("ALAMAT").setValue("");
														$$("PASIENID").setValue("");
														$$("PATIENTTYPE").setValue("");
														$$("NOKARTUBPJS").setValue("");
														$$("NOKARTUBPJS").hide();
														$$("NOTELEPON").setValue("");
														$$("EMAIL").setValue("");
														//$$("DEPT").setValue("");
														$$("GUDANG").setValue("");
														$$("RESERV_TEMPLATE").hide();
														$$("jenis_antrian").hide();
														$$("NAMAPASIEN").hide();
														$$("tgllahir_reserv").hide();
														$$("kelamin_reserv").hide();
														$$("ALAMAT").hide();
														$$("patienttype_reserv").hide();
														$$("NOTELEPON").hide();
														$$("EMAIL").hide();
														$$("gudang_reserv").hide();
														$$("SAVE").hide();
														html2 = '<table style="width: 100%; font-family: Arial, Helvetica, sans-serif;">';
														html2 += '<tr><td style="text-align:center; font-size:14pt; text-decoration: underline;" colspan="2">Nomor Antrean Registrasi</td></tr>';
														html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif; font-size:100pt;" colspan="2">'+text+'</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:10pt;" colspan="2">Silakan ke meja registrasi pasien jika dipanggil</td></tr>';
														html2 += '</table>';
														$$("RESERV_TEMPLATE").setHTML(html2);
														$$("BACK_BUTTON").show();
														if (computerid) {
															$$("PRINT_ANTREAN").show();
														}
														$$("RESERV_TEMPLATE").define("height", window.innerHeight-300);
														$$("RESERV_TEMPLATE").resize();
													} else {
														webix.message({ type:"error", text:"Ada masalah pada saat simpan data. Silakan coba sebentar lagi"});
													}    	
												});
											}
										} else {
											var form = $$("DaftarHeader");
											if (form.validate()) {
												$$("SAVE").disable();
												var values = form.getValues();
												// console.log(values);
												var url = "server/masterdata.php?id=DOREGISTER";
												webix.ajax().post(url, values, function(text) {
													// console.log(text);
													if (text) {
														var rdata = JSON.parse(text);
														// webix.message({ type:"success", text:text});
														webix.UIManager.setFocus($$('PASIENID'));
														$$("NAMAPASIEN").setValue("");
														$$("TGLLAHIR").setValue("");
														$$("SEX").setValue("");
														$$("ALAMAT").setValue("");
														// $$("PASIENID").setValue("");
														$$("PATIENTTYPE").setValue("");
														$$("NOKARTUBPJS").setValue("");
														$$("NOKARTUBPJS").hide();
														$$("NOTELEPON").setValue("");
														$$("EMAIL").setValue("");
														// $$("RESERV_TEMPLATE").hide();
														$$("jenis_antrian").hide();
														$$("NAMAPASIEN").hide();
														$$("tgllahir_reserv").hide();
														$$("kelamin_reserv").hide();
														$$("ALAMAT").hide();
														$$("patienttype_reserv").hide();
														$$("NOTELEPON").hide();
														$$("EMAIL").hide();
														$$("gudang_reserv").hide();
														$$("SAVE").hide();
														$$("RESERV_TEMPLATE").show();
														var timestamp = new Date().getTime();
														// html2 = '<table style="width: 100%; font-family: Arial, Helvetica, sans-serif;">';
														// html2 += '<tr><td style="text-align:center; font-size:14pt; text-decoration: underline;" colspan="3">Nomor Antrean</td></tr>';
														// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif; font-size:100pt;" colspan="3">'+rdata.response.nomorantrean+'</td></tr>';
														// html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata.response.transid+'.png?'+timestamp+'"/></td></tr>';
														// // html2 += '<tr><td style="text-align:center; font-family: Arial, Helvetica, sans-serif;" colspan="3"><img src="server/qrcode.php?id='+rdata.response.transid+'&'+timestamp+'"/></td></tr>';
														// html2 += '<tr><td style="width:48%; text-align:right; font-size:10pt;">Sisa Antrean: '+rdata.response.sisaantrean+'</td>';
														// html2 += '<td style="width:4%; text-align:right; font-size:10pt;"></td>';
														// html2 += '<td style="width:48%; text-align:left; font-size:10pt;">Antrean Dipanggil: '+rdata.response.antreanpanggil+'</td></tr>';
														// html2 += '</table>';
														html2 = '<table style="width: 100%; font-family: Calibri, sans-serif;">';
														html2 += '<tr><td style="text-align:center; font-size:21pt; font-weight: bold; height: 55px;" colspan="3">KLINIK PENTA MEDICA</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:6pt;" colspan="3"></td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">NOMOR ANTREAN</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:18pt;" colspan="3">'+rdata.response.namapoli+'</td></tr>';
														html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif; font-size:100pt; font-weight: bold;" colspan="3">'+rdata.response.nomorantrean+'</td></tr>';
														html2 += '<tr><td style="text-align:center; font-family: Calibri, Arial, Helvetica, sans-serif;" colspan="3"><img src="assets/imgs/qrcode/S_'+rdata.response.transid+'.png?'+timestamp+'"/></td></tr>';
														html2 += '<td style="width:4%; text-align:right; font-size:8pt;"></td>';
														html2 += '<tr><td style="text-align:center; font-size:13pt; font-weight: bold;" colspan="3">Sisa Antrean: '+rdata.response.sisaantrean+'</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:12pt; font-weight: bold;" colspan="3">Antrean Dipanggil: '+rdata.response.antreanpanggil+'</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:14pt;" colspan="3">'+rdata.response.antreandate+'</td></tr>';
														html2 += '<td style="width:4%; text-align:right; font-size:8pt;"></td>';
														html2 += '<tr><td style="text-align:center; font-size:11pt;" colspan="3">Jika antrean terlewat mohon</td></tr>';
														html2 += '<tr><td style="text-align:center; font-size:11pt;" colspan="3">untuk melakukan pendaftaran ulang</td></tr>';
														html2 += '</table>';
														$$("RESERV_TEMPLATE").setHTML(html2);
														$$("BACK_BUTTON").show();
														if (computerid) {
															$$("PRINT_ANTREAN").show();
														}
														$$("RESERV_TEMPLATE").define("height", window.innerHeight-300);
														$$("RESERV_TEMPLATE").resize();
													} else {
														webix.message({ type:"error", text:"Ada masalah pada saat simpan data. Silakan coba sebentar lagi"});
													}    	
												})
											}
										}
				                	} 
								}
							]
						}
					],
					rules:{
						$obj:function(data){
							if (!data.PASIENID){
								webix.message({ type:"error", text:"Please input NIK/Passport/Insurance No./BPJS<br>Silakan isi NIK/Passport/No. Asuransi/BPJS Penta anda"});
								return false;
							}
							if (!data.NAMAPASIEN){
								webix.message({ type:"error", text:"Please input your name<br>Silakan isi nama anda"});
								return false;
							}
							if (data.SEX == '-1'){
								webix.message({ type:"error", text:"Please input your gender<br>Silakan isi jenis kelamin anda"});
								return false;
							}
							if (!data.TGLLAHIR){
								webix.message({ type:"error", text:"Please input your date of birth<br>Silakan isi tanggal lahir anda"});
								return false;
							}
							if ((!data.DEPT) || (data.DEPT == '-1')) {
								webix.message({ type:"error", text:"Please select location<br>Silakan pilih lokasi"});
								return false;
							}
							if ((!data.GUDANG) || (data.GUDANG*1 == 0)) {
								webix.message({ type:"error", text:"Please select policlinic<br>Silakan pilih poliklinik"});
								return false;
							}
							if (!data.ALAMAT){
								webix.message({ type:"error", text:"Please input your address<br>Silakan isi alamat anda"});
								return false;
							}
							if ((!data.PATIENTTYPE) || (data.PATIENTTYPE == '-1')) {
								webix.message({ type:"error", text:"Please select your prefered type<br>Silakan pilih jenis pasien anda"});
								return false;
							}
							if (data.PATIENTTYPE == 'BPJS'){
								if (!data.NOKARTUBPJS) {
									webix.message({ type:"error", text:"Silakan masukkan nomor kartu untuk pasien BPJS"});
									return false;
								}
							}
							// if (!data.NOTELEPON){
							// 	webix.message({ type:"error", text:"Please input your phone number<br>Silakan isi nomor telepon anda"});
							// 	return false;
							// }
							// if (!data.EMAIL){
							// 	webix.message({ type:"error", text:"Please input your email address<br>Silakan isi alamat email anda"});
							// 	return false;
							// }
							return true;
						}
				    }        
				}
			},
		]
    };

	var layoutClosed = {
		type: "space",
		rows: [
			{ view: "label", label:"Jam registrasi belum dibuka atau sudah habis", id:"OUT_OF_TIME", css: "warnLabel"}
		]
	}

	// var dept = webix.storage.session.get("location");
	// webix.ajax("server/masterdata.php?id=GETDEPT&dept="+dept, function(text){
	// 	console.log(text);
	// 	rdata = JSON.parse(text);
	// 	if (rdata[0].CANREGIST*1 == 0) {
	// 		return { $ui:layoutClosed };
	// 	} else {
			// return { $ui:layout };
	// 	}
	// });
	return { $ui:layout };
	// return { $ui:layout };

});

define('views/menus/export',[],function(){

	return {
		$ui:{
			view: "submenu",
			id: "exportPopup",
			width: 200,
			padding:0,
			data: [
				{id: 1, icon: "file-excel-o", value: "Export To Excel"},
				{id: 2, icon: "file-pdf-o", value: "Export To PDF"}
			],
			on:{
				onItemClick:function(id){
					if(id==1){
						$$("orderData").exportToExcel();
					}
					else if(id==2)
						$$("orderData").exportToPDF();
				}
			}
		}
	};
});
define('views/reprint',[],function(){


	var layout = {
		type:"clean",
		rows: [
			{ header:"Cek Perjanjian Pol Gigi", body:{
				view:"form", 
				autoheight: false, 
				height: 100, 
				id:"DaftarHeader", 
				scroll: true, 
				margin: 4, 
					elements:[
						{
							cols: [
								// { view:"text", id:"PASIENID", name:"PASIENID", label: "NIK/Passport", labelWidth: 104, width:270 },
								{ view:"text", id:"PASIENID", name:"PASIENID", label: "NIK/Passport/No. Asuransi/BPJS Penta ", labelPosition: "top", width:260 },
								{ view: "button", type: "iconButton", id:"CHECK_RM", icon:"check", width:76, label:"Check",
									click:function(){
										var norm = $$("PASIENID").getValue();
										if (norm) {
	                                        var grid = $$("DataAntrian");
											grid.hide();
	                                        webix.ajax("server/masterdata.php?id=GETRESERVATION&norm="+norm, function(text){
	                                            if (text != "[]") {
	                                            	$$("NOT_FOUND_LABEL").hide();
	                                            	grid.clearAll();
	                                            	grid.show();
	                                            	grid.load("server/masterdata.php?id=GETRESERVATION&norm="+norm);
	                                            } else {
	                                            	$$("NOT_FOUND_LABEL").show();
	                                            	grid.hide();
	                                            }
	                                        })
										}
									}
								}, 
								{}
							]
						},
						{ view: "label", label:"Appointment not found/Data perjanjian tidak ditemukan", id:"NOT_FOUND_LABEL", css: "warnLabel", hidden:true},
			            {
			                view:"datatable", 
			                hidden:true,
			                id:"DataAntrian", 
			                height:200, 
			                select:true, 
			                editable:false, 
			                navigation: true, 
			                tooltip:true,
			                rightSplit:1,
			                columns:[
			                   // {id:"nomor", header:{text:"No.", css:{'text-align':'center'}}, css:{'text-align':'center'}, width:35},
			                    {id:"RESERVDATE", header:"Date", sort:"string", width:80, format:webix.i18n.dateFormatStr},
			                    // {id:"nomorrm", header:"No. RM", css:{'text-align':'center'}, sort:"string", width:80},
			                    {id:"DEPT", header: "Location", sort:"string", width:80},
			                    {id:"GUDANG", header: "Policlinic", sort:"string", width:120},
			                    {id:"NAMAPASIEN", header: "Name", sort:"string", width:150},
			                    {id:"ALAMAT", header: "Address", sort:"string", width:200},
			                    {id:"RESERVNO", header:{text:"Appt. #", css:{'text-align':'right'}}, sort:"string", css:{'text-align':'right'}, width:90},
			                    {id:"MEDICALRESERVID", header:"", hidden:true},
			                    {id:"select", header:"Action",
			                        template:function(obj){ 
			                            return "<div class='webix_el_button'><button class='webixtype_base'> Print</button></div>";
			                        }
			                    }
			                ],
			                onClick:{
			                    "webixtype_base":function(ev,id,html){
                                    var grid = $$("DataAntrian");
                                    var item = grid.getItem(id);
		                            webix.confirm({
		                                title: "K O N F I R M A S I",
		                                width: "300px",
		                                text:"Reprint appointment/Cetak ulang perjanjian ini?", 
		                                ok:"Ya", cancel:"Tidak",
		                                callback:function(res){
		                                    if(res){
												window.open("server/printantrian.php?reservid="+item.MEDICALRESERVID);
		                                    }
		                                }
		                            });
			                    }
			                },
			                on:{
			                    onBeforeLoad:function(){
			                       this.showOverlay("Loading...");
			                    },
			                    onAfterLoad:function(){
			                        this.hideOverlay();
			                    }
			                }
			            }
					],
					rules:{
						$obj:function(data){
							// if (!data.CUSTID){
							// 	webix.message({ type:"error", text:"Silakan masukkan nama customer"});
							// 	return false;
							// }
							// if (!data.SALESPERSONID){
							// 	webix.message({ type:"error", text:"Silakan masukkan nama sales"});
							// 	return false;
							// }
							return true;
						}
				    }        
				}
			},
		]
    };

	return { $ui:layout };

});

webix.protoUI({
	name:"ckeditor",
	$init:function(config){
		this.$view.className += " webix_selectable";
	},
	defaults:{
		borderless:true,
		toolbar: [
			[ 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', '-', 'Link', 'Unlink' ],
			[ 'FontSize', 'TextColor', 'BGColor' ]
		]
	},
	_init_ckeditor_once:function(){
		var tid = this.config.textAreaID = "t"+webix.uid();
		this.$view.innerHTML = "<textarea id='"+tid+"'>"+this.config.value+"</textarea>";

		window.CKEDITOR_BASEPATH = webix.codebase+"ckeditor/";
		var t = {
			toolbar: this.config.toolbar,
			width:this.$width -2,
			height:this.$height - 44
		};
		webix.extend(t,this.config.editor||{});
		webix.require("ckeditor/ckeditor.js", function(){
			this._3rd_editor = CKEDITOR.replace( this.config.textAreaID, t);
		}, this);
	},
	_set_inner_size:function(x, y){
		if (!this._3rd_editor || !this._3rd_editor.container || !this.$width) return;
		this._3rd_editor.resize(x, y);
	},
	$setSize:function(x,y){
		if (webix.ui.view.prototype.$setSize.call(this, x, y)){
			this._init_ckeditor_once();
			this._set_inner_size(x,y);
		}
	},
	setValue:function(value){
		this.config.value = value;
		if (this._3rd_editor)
			this._3rd_editor.setData(value);
		else webix.delay(function(){
			this.setValue(value);
		},this,[],100);
	},
	getValue:function(){
		return this._3rd_editor?this._3rd_editor.getData():this.config.value;
	},
	focus:function(){
		this._focus_await = true;
		if (this._3rd_editor)
			this._3rd_editor.focus();
	},
	getEditor:function(){
		return this._3rd_editor.getData();
	}
}, webix.ui.view);
define("views/webix/ckeditor", function(){});

webix.protoUI({
	name:"edittree"
}, webix.EditAbility, webix.ui.tree);
define("views/webix/editable", function(){});

webix.type(webix.ui.tree, {
	name:"fileTree",
	css: "file",
	height: 40,
	templateCommon:webix.template("{common.icon()} <div class='folder_title'>{common.folder()} #value#</div>"),
	folder:function(obj, common){
		return "<span class='webix_icon icon fa-folder"+(obj.open?"-open":(obj.$level>3?"-o":""))+"'></span>";
	}
});
define("views/webix/filetree", function(){});

webix.type(webix.ui.dataview, {
	name:"fileView",
	css: "files",
	height: 80,
	width: 150,

	template: function(obj){
		var icon = (obj.icon||"folder-o");
		return "<div class='"+(obj.type||"folder")+"'><span class='webix_icon fa-"+icon+"'></span></div>"+obj.value;
	}

});
define("views/webix/fileview", function(){});

webix.protoUI({
	name:"google-map",
	$init:function(config){
		this.$view.innerHTML = "<div class='webix_map_content' style='width:100%;height:100%'></div>";
		this._contentobj = this.$view.firstChild;

		this._waitMap = webix.promise.defer();
		this.$ready.push(this.render);
	},
	getMap:function(waitMap){
		return waitMap?this._waitMap:this._map;
	},
	render:function(){

        if(typeof google=="undefined"||typeof google.maps=="undefined"){
            var name = "webix_callback_"+webix.uid();
            window[name] = webix.bind(function(){
				this._initMap.call(this,true);
            },this);

            var script = document.createElement("script");
            script.type = "text/javascript";
            var src = "//maps.google.com/maps/api/js?callback="+name;

            if (this.config.key)
				src += "&key="+this.config.key;
            if (this.config.libraries)
				src += "&libraries="+this.config.libraries;

            script.src = src;
            document.getElementsByTagName("head")[0].appendChild(script);
        }
        else
            this._initMap();
	},
    _initMap:function(define){
        var c = this.config;
        if(this.isVisible(c.id)){
			this._map = new google.maps.Map(this._contentobj, {
				zoom: c.zoom,
				center: new google.maps.LatLng(c.center[0], c.center[1]),
				mapTypeId: google.maps.MapTypeId[c.mapType]
			});
			this._waitMap.resolve(this._map);
        }
    },
	center_setter:function(config){
		if(this._map)
            this._map.setCenter(new google.maps.LatLng(config[0], config[1]));
        
		return config;
	},
	mapType_setter:function(config){
		/*ROADMAP,SATELLITE,HYBRID,TERRAIN*/
        if(this._map)
			this._map.setMapTypeId(google.maps.MapTypeId[config]);

		return config;
	},
	zoom_setter:function(config){
		if(this._map)
			this._map.setZoom(config);

		return config;
	},
	defaults:{
		zoom: 5,
		center:[ 39.5, -98.5 ],
		mapType: "ROADMAP"
	},
	$setSize:function(){
		webix.ui.view.prototype.$setSize.apply(this, arguments);
		if(this._map)
            google.maps.event.trigger(this._map, "resize");
	}
}, webix.ui.view);

define("views/webix/googlemap", function(){});

// Type for left menu
webix.type(webix.ui.tree, {
	name:"menuTree",
	height: 40,
	icon:function(obj, common){
		var html = "";
		/*var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
			}
		}*/
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
webix.type(webix.ui.tree, {
	name:"menuTree2",
	height: 40,

	icon:function(obj, common){
		var html = "";
		var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
		    }
		}
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
define("views/webix/menutree", function(){});

webix.protoUI({
	name:"dhx-scheduler",
	defaults:{
		tabs:["day", "week", "month"]
	},
	getScheduler:function(){
		return this._scheduler;
	},
	$init:function(config){
		this.$ready.push(function(){
			var tabs = this.config.tabs;

			var html = ["<div class='dhx_cal_container' style='width:100%; height:100%;'><div class='dhx_cal_navline'><div class='dhx_cal_prev_button'>&nbsp;</div><div class='dhx_cal_next_button'>&nbsp;</div><div class='dhx_cal_today_button'></div><div class='dhx_cal_date'></div>"];
			if (tabs)
				for (var i=0; i<tabs.length; i++)
					html.push("<div class='dhx_cal_tab" +
						((i===0)?" dhx_cal_tab_first":"") +
						((i==tabs.length-1)?" dhx_cal_tab_last":"") +
						"' name='"+tabs[i]+"_tab' ></div>");
			html.push("</div><div class='dhx_cal_header'></div><div class='dhx_cal_data'></div></div>");

			this.$view.innerHTML = html.join("");

			//because we are not messing with resize model
			//if setSize will be implemented - below line can be replaced with webix.ready
			webix.delay(webix.bind(this._render_once, this));
		});
	},
	_render_once:function(){
		webix.require("scheduler/dhtmlxscheduler.css");
		webix.require([
			"scheduler/dhtmlxscheduler.js"
		], function(){
			var scheduler = this._scheduler = window.Scheduler ? Scheduler.getSchedulerInstance() : window.scheduler;

			if (this.config.init)
				this.config.init.call(this);

			scheduler.init(this.$view.firstChild, (this.config.date||new Date()), (this.config.mode||"week"));
			if (this.config.ready)
				this.config.ready.call(this);

		}, this);
	}
}, webix.ui.view);
define("views/webix/scheduler", function(){});

require(["app"]);
